<template>
  <div class="body-small pace-done" :class="currentTheme">
    <div
      class="border-bottom"
      v-if="authenticated && getNavbarstatus && !currentPage && rollsprivilages != undefined"
    >
      <nav
        v-if="authenticated && getNavbarstatus && !currentPage && rollsprivilages != undefined"
        class="navbar navbar-static-top"
        role="navigation"
        style="margin-bottom: 0"
      >
        <div
          class="navbar-header align-self-center d-flex justify-content-between"
        >
          <div class="navbar-logo profile-element navbar-header-bg">
            <img src="../../assets/img/IDSLogo.png" alt="Logo" />
          </div>
          <div
            class="navbar-logo profile-element navbar-header-bg border-left-blue border-bottom-blue"
          >
            <img src="../../assets/img/client_Logo.png" alt="Logo" />
          </div>
          <div class="logo-element navbar-header-bg">
            <img src="../../assets/img/IDS_small_Logo.png" alt="Logo" />
          </div>
          <div
            class="logo-element navbar-header-bg border-left-blue border-bottom-blue"
          >
            <img src="../../assets/img/client_Logo.png" alt="Logo" />
          </div>
        </div>
        <a
          v-if="showArrows && !hideSideNavbar"
          aria-label="Collapsible menu icon"
          tabindex="0"
          class="btn-cps ml-2 position-relative"
          href="#"
          @click.prevent="collapse()"
        >
          <img
            src="../../assets/img/collapse_icon_left.svg"
            alt="collapse"
            v-if="isActive"
          />
          <div v-if="isActive" class="tool-tip" style="top: 30px; right: 30px">
            Close Sidebar
          </div>
          <img
            src="../../assets/img/collapse_icon_right.svg"
            alt="collapse"
            v-if="isRightActive"
          />
          <div
            v-if="isRightActive"
            class="tool-tip"
            style="top: 30px; right: 30px"
          >
            Open Sidebar
          </div>
          <!-- <i class="fa fa-bars" v-if="isActive"></i>
                <i class="fa fa-bars" v-if="isRightActive"></i> -->
        </a>
        <!-- Mobile hamburger: only visible at ≤768px -->
        <button
          class="mobile-hamburger"
          @click.stop="mobileNavOpen = !mobileNavOpen"
          aria-label="Toggle navigation menu"
        >
          <i class="fa" :class="mobileNavOpen ? 'fa-times' : 'fa-bars'"></i>
        </button>
        <ul
          class="nav navbar-top-links navbar-right flex-grow-1 justify-content-end align-items-center"
        >
          <!-- <li
                class="px-1 add-study-popup cursor-pointer"
                @click.prevent="openUploadFile()"
                aria-label="Add study"             
                tabindex="0"
              >
                <img
                 class="px-md-1"
                  src="../../assets/img/upload_pdf.png"
                  alt="Upload file"
                />
                <div class="tool-tip">{{ $t("navigations.upload study protocol") }}</div>
              </li> -->
          <li
            class="px-1 add-study-popup cursor-pointer"
            aria-label="Default Settings"
            tabindex="0"
            @keydown.enter.prevent="DefaultSetupPopUp = true"
          >
            <img
              class="px-md-1"
              src="../../assets/img/default_setup.png"
              alt="Default Settings"
              @click.prevent="DefaultSetupPopUp = true"
            />
            <div class="tool-tip">{{ $t("navigations.default preferences") }}</div>
          </li>
              
          <li
            v-if="rollsprivilages.includes('Video Call Schedule Video Call')"
            class="px-1 add-study-popup cursor-pointer"
            aria-label="Schedule Video call"
            tabindex="0"
          >
            <img
              class="px-md-1"
              src="../../assets/img/video_call_nav.png"
              alt="Schedule Video call"
              @click.prevent="CreateVideoCallSchedulePopUp = true"
            />
            <div class="tool-tip">Schedule Video call</div>
          </li>
          
          <!-- <li

                class="px-1 add-study-popup cursor-pointer"
                aria-label="Add study"
                tabindex="0"
              >
                <img
                  class="px-md-1"
                  src="../../assets/img/video_call_nav.png"
                  alt="Schedule Video call"
                  @click.prevent="ViewReportPopUp = true"
                />
                <div class="tool-tip">view report</div>
              </li> -->
          <li
            v-if="rollsprivilages.includes('Studylist Import Study')"
            class="px-3 px-md-2 add-study-popup cursor-pointer"
            @click.prevent="importStudypopup('study')"
            aria-label="Import study"
            tabindex="0"
          >
            <img
              src="../../assets/img/import_study2.png"
              alt="Import study details"
            />
            <div class="tool-tip">{{ $t("navigations.import study") }}</div>
          </li>
          <li
            v-if="rollsprivilages.includes('Studylist Concept map Builder')"
            class="px-1 px-md-2 add-study-popup cursor-pointer"
            @click.prevent="importStudypopup('SoA')"
            aria-label="Import SoA"
            tabindex="0"
          >
            <img
              src="../../assets/img/import_study.png"
              alt="Import SoA details"
            />
            <div class="tool-tip">{{$t("navigations.Concept map Builder") }}</div>
          </li>
          <li
            v-if="rollsprivilages.includes('Studylist Create Study')"
            class="px-1 add-study-popup cursor-pointer"
            @click.prevent="createstudypopup = true"
            aria-label="Create study"
            tabindex="0"
          >
            <img
              class="px-md-1"
              src="../../assets/img/CreateStudy_n.png"
              alt="Create Study"
            />
            <div class="tool-tip">{{ $t("navigations.create study") }}</div>
          </li>

          <li class="px-1 px-md-2" aria-label="Change study" tabindex="0">
            <select
              class="study-select"
              name="Select Study"
              v-model="valnow"
              @change.prevent="studychange($event.target.value)"
            >
              <option selected disabled value="">Select Study</option>

              <option
                v-for="studie in studies"
                :key="studie.studyId"
                :value="studie.studyId"
              >
                {{ studie.studyRef }}
              </option>
            </select>
          </li>
          <li
            v-if="rollsprivilages.includes('Query Menu General')"
            class="px-2 px-md-2 general-query cursor-pointer"
            aria-label="Add a general query"
            tabindex="0"
          >
            <div
              class="px-0 cursor-pointer"
              @click.prevent="gotoUrl('generalQuery')"
            >
              <img
                src="../../assets/img/general_query_n.png"
                alt="General Query"
              />
            </div>
            <div class="tool-tip">
              {{ $t("navigations.general query") }}
            </div>
          </li>
          <!-- <li aria-label="Add a general query" tabindex="0">
                <a
                  @click.prevent="gotoUrl('generalQuery')"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="General query"
                >
                  <img src="../../assets/img/general_query_n.png" alt="General Query" />
                </a>
              </li> -->
          <li
            v-if="rollsprivilages.includes('Query Menu Received')"
            class="px-1 px-md-2 received-query cursor-pointer"
            aria-label="Received query notification"
            tabindex="0"
          >
            <div
              class="count-info px-0 cursor-pointer"
              @click.prevent="displayNotification()"
              data-toggle="tooltip"
              data-placement="top"
            >
              <img
                class="query-icon"
                src="../../assets/img/received_query_n.png"
                alt="Received Query"
              />
              <span class="label label-warning query-count">{{
                querycount
              }}</span>
              <div class="tool-tip">
                {{ $t("navigations.received queries") }}
              </div>
              <div class="notification-block animate fadeIn">
                <div class="d-flex flex-column">
                  <div class="message-header d-flex flex-column py-1">
                    <h5 class="text-start">
                      {{ $t("navigations.received queries") }}
                    </h5>
                    <span class="dropdown-divider"></span>
                  </div>

                  <div
                    class="message-body d-flex"
                    v-for="list in querylist.slice(0, 3)"
                    :key="list.id"
                  >
                    <div
                      class="message-body__left-block text-start"
                      @click.prevent="viewquery(list.id)"
                    >
                      <span class="d-inline-block mb-1"
                        ><strong>{{ list.raisedBy }}</strong> raised query
                        regarding <strong>{{ list.subject }}</strong></span
                      >
                      <span class="d-inline-block mb-2"
                        ><small class="text-muted"
                          >{{ filterTime(list.date) }} -
                          {{ filterDate(list.date) }}</small
                        ></span
                      >
                    </div>
                    <div
                      class="message-body__right-block"
                      @click.prevent="viewquery(list.id)"
                    >
                      <span class="d-inline-block mb-1">{{
                        filterNow(list.date)
                      }}</span
                      ><br />
                    </div>
                    <span class="dropdown-divider"></span>
                  </div>
                </div>
                <div
                  class="text-center link-block py-1 px-0"
                  @click.prevent="gotoUrl('queryList')"
                >
                  <a class="dropdown-item">
                    <i class="fa fa-question-circle-o"></i>
                    <strong>{{ $t("navigations.read all queries") }}</strong>
                  </a>
                </div>
              </div>
            </div>
          </li>
          

          <li
            class="px-2 px-md-2 user-profile cursor-pointer"
            aria-label="User profile"
            tabindex="0"
          >
            <div
              class="user-block px-0 cursor-pointer"
              @click.prevent="displayProfile()"
              data-toggle="tooltip"
              data-placement="top"
            >
              <img
                :src="usersdetails.picture"
                class="img-fluid profile-pic"
                alt="User"
              />
              <div class="tool-tip">
                {{ $t("navigations.user profile") }}
              </div>
            </div>
            <div class="profile-block animate fadeIn text-start">
              <div
                class="login-user-details d-flex justify-content-start align-items-center"
              >
                <div class="login-user-details--image">
                  <img
                    class="profile-pic me-2"
                    :src="usersdetails.picture"
                    alt="User Image"
                  />
                </div>
                <div class="login-user-details--details d-flex flex-column">
                  <span
                    ><b>{{ usersdetails.given_name }}</b></span
                  >
                  <span>{{ usersdetails.name }}</span>
                  <span v-if="currentRoleName"> {{ currentRoleName }}</span>
                </div>
              </div>
              <div class="user-details d-flex flex-column">
                <div
                  class="theme-change-block d-flex justify-content-start align-items-center"
                  @click="gotoUrl('profileSettings')"
                >
                  <img
                    class="me-2"
                    src="../../assets/img/user_profile.png"
                    alt="User Profile"
                  />
                  <span>{{ $t("navigations.profile") }}</span>
                </div>
                <div
                  class="theme-change-block d-flex justify-content-start align-items-center"
                  @click="expandSidebar()"
                >
                  <img
                    class="me-2"
                    src="../../assets/img/user_themes.png"
                    alt="User Themes"
                  />
                  <span class="theme-change-block">{{
                    $t("navigations.themes")
                  }}</span>
                  <div class="theme-menu animated fadeIn">
                    <div class="title">Themes</div>
                    <div
                      class="setings-item default-skin"
                      @click="switchTheme('theme-default')"
                    >
                      <span class="skin-name">
                        <a href="#" class="md-skin"> Default </a>
                      </span>
                    </div>
                    <!-- <div class="setings-item blue-skin" @click="themeBlack()">
                              <span class="skin-name ">
                                <a href="#" class="s-skin-1">
                                  Black light
                                </a>
                              </span>
                            </div> -->
                    <div
                      class="setings-item teal-skin"
                      @click="switchTheme('theme-green')"
                    >
                      <span class="skin-name">
                        <a href="#" class="md-skin"> Teal Green </a>
                      </span>
                    </div>
                    <div
                      class="setings-item dusty-skin"
                      @click="switchTheme('theme-violet')"
                    >
                      <span class="skin-name">
                        <a href="#" class="md-skin"> Dusty Lavender </a>
                      </span>
                    </div>
                    <div
                      class="setings-item ocean-skin"
                      @click="switchTheme('theme-ocian')"
                    >
                      <span class="skin-name">
                        <a href="#" class="md-skin"> Ocean Green </a>
                      </span>
                    </div>
                    <div
                      class="setings-item stormy-skin"
                      @click="switchTheme('theme-stormy')"
                    >
                      <span class="skin-name">
                        <a href="#" class="md-skin"> Stormy Cloud </a>
                      </span>
                    </div>
                    <div
                      class="setings-item pastel-skin"
                      @click="switchTheme('theme-pastel')"
                    >
                      <span class="skin-name">
                        <a href="#" class="md-skin"> Pastel Russet </a>
                      </span>
                    </div>
                  </div>
                </div>
                <span class="dropdown-divider"></span>
                <div
                  class="theme-change-block d-flex justify-content-start align-items-center"
                  @click.prevent="logout"
                >
                  <img
                    class="me-2"
                    src="../../assets/img/logout.png"
                    alt="Logout"
                  />
                  <span>{{ $t("navigations.logout") }}</span>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <!-- Mobile nav overlay -->
        <div
          class="mobile-nav-overlay"
          :class="{ 'is-visible': mobileNavOpen }"
          @click="mobileNavOpen = false"
        ></div>

        <!-- Mobile nav drawer (slides in from right) -->
        <div
          class="mobile-nav-drawer"
          :class="{ 'is-open': mobileNavOpen }"
          @click.stop
        >
          <div class="mobile-nav-header">
            <span class="mobile-nav-title">Menu</span>
            <button class="mobile-nav-close-btn" @click="mobileNavOpen = false" aria-label="Close menu">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="mobile-nav-content">
            <div class="mobile-nav-section">
              <select
                class="mobile-study-select"
                name="Select Study"
                v-model="valnow"
                @change.prevent="studychange($event.target.value)"
              >
                <option selected disabled value="">Select Study</option>
                <option
                  v-for="studie in studies"
                  :key="studie.studyId"
                  :value="studie.studyId"
                >{{ studie.studyRef }}</option>
              </select>
            </div>
            <ul class="mobile-nav-list">
              <li
                v-if="rollsprivilages.includes('Video Call Schedule Video Call')"
                class="mobile-nav-list-item"
                @click.prevent="CreateVideoCallSchedulePopUp = true; mobileNavOpen = false"
              >
                <img src="../../assets/img/video_call_nav.png" alt="Schedule Video call" />
                <span>Schedule Video call</span>
              </li>
              <li
                class="mobile-nav-list-item"
                @click.prevent="DefaultSetupPopUp = true; mobileNavOpen = false"
              >
                <img src="../../assets/img/settings.png" alt="Default Settings" />
                <span>{{ $t("navigations.default settings") }}</span>
              </li>
              <li
                v-if="rollsprivilages.includes('Studylist Import Study')"
                class="mobile-nav-list-item"
                @click.prevent="importStudypopup('study'); mobileNavOpen = false"
              >
                <img src="../../assets/img/import_study2.png" alt="Import study" />
                <span>{{ $t("navigations.import study") }}</span>
              </li>
              <li
                v-if="rollsprivilages.includes('Studylist Concept map Builder')"
                class="mobile-nav-list-item"
                @click.prevent="importStudypopup('SoA'); mobileNavOpen = false"
              >
                <img src="../../assets/img/import_study.png" alt="Concept map Builder" />
                <span>{{ $t("navigations.Concept map Builder") }}</span>
              </li>
              <li
                v-if="rollsprivilages.includes('Studylist Create Study')"
                class="mobile-nav-list-item"
                @click.prevent="createstudypopup = true; mobileNavOpen = false"
              >
                <img src="../../assets/img/CreateStudy_n.png" alt="Create Study" />
                <span>{{ $t("navigations.create study") }}</span>
              </li>
              <li
                v-if="rollsprivilages.includes('Query Menu General')"
                class="mobile-nav-list-item"
                @click.prevent="gotoUrl('generalQuery'); mobileNavOpen = false"
              >
                <img src="../../assets/img/general_query_n.png" alt="General Query" />
                <span>{{ $t("navigations.general query") }}</span>
              </li>
              <li
                v-if="rollsprivilages.includes('Query Menu Received')"
                class="mobile-nav-list-item"
                @click.prevent="gotoUrl('queryList'); mobileNavOpen = false"
              >
                <img src="../../assets/img/received_query_n.png" alt="Received Queries" />
                <span>{{ $t("navigations.received queries") }}</span>
                <span v-if="querycount" class="mobile-query-badge">{{ querycount }}</span>
              </li>
            </ul>
            <span class="dropdown-divider mx-3"></span>
            <div class="mobile-user-section">
              <div class="mobile-user-info">
                <img :src="usersdetails.picture" class="mobile-profile-pic" alt="User" />
                <div class="mobile-user-name">
                  <b>{{ usersdetails.given_name }}</b>
                  <span>{{ usersdetails.name }}</span>
                </div>
              </div>
              <ul class="mobile-nav-list">
                <li
                  class="mobile-nav-profile-item"
                  @click.prevent="gotoUrl('profileSettings'); mobileNavOpen = false"
                >
                  <img src="../../assets/img/user_profile.png" alt="Profile" />
                  <span>{{ $t("navigations.profile") }}</span>
                </li>
                <li
                  class="mobile-nav-profile-item"
                  @click.stop="mobileThemeOpen = !mobileThemeOpen"
                >
                  <img src="../../assets/img/user_themes.png" alt="Themes" />
                  <span>{{ $t("navigations.themes") }}</span>
                  <i class="fa ms-auto" :class="mobileThemeOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </li>
                <li v-show="mobileThemeOpen" class="mobile-theme-submenu">
                  <div class="mobile-theme-item default-skin" @click="switchTheme('theme-default'); mobileNavOpen = false">Default</div>
                  <div class="mobile-theme-item teal-skin" @click="switchTheme('theme-green'); mobileNavOpen = false">Teal Green</div>
                  <div class="mobile-theme-item dusty-skin" @click="switchTheme('theme-violet'); mobileNavOpen = false">Dusty Lavender</div>
                  <div class="mobile-theme-item ocean-skin" @click="switchTheme('theme-ocian'); mobileNavOpen = false">Ocean Green</div>
                  <div class="mobile-theme-item stormy-skin" @click="switchTheme('theme-stormy'); mobileNavOpen = false">Stormy Cloud</div>
                  <div class="mobile-theme-item pastel-skin" @click="switchTheme('theme-pastel'); mobileNavOpen = false">Pastel Russet</div>
                </li>
                <li
                  class="mobile-nav-profile-item"
                  @click.prevent="logout(); mobileNavOpen = false"
                >
                  <img src="../../assets/img/logout.png" alt="Logout" />
                  <span>{{ $t("navigations.logout") }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>

    <nav
      class="navbar navbar-static-top"
      v-if="currentPage == true"
      role="navigation"
    >
      <!-- <div class="landing-nav-header"><img src="../../assets/img/IDSLogo.png" alt="Logo" /></div > -->
      <div
        class="navbar-header align-self-center d-flex justify-content-between"
      >
        <div class="navbar-logo profile-element navbar-header-bg">
          <img
            v-if="$router.currentRoute.value.name != 'f4pViewer'"
            src="../../assets/img/IDSLogo.png"
            alt="Logo"
          />
          <img v-else src="../../assets/img/fhir4pharma_logo.png" alt="Logo" />
        </div>
        <div
          class="navbar-logo profile-element navbar-header-bg border-left-blue border-bottom-blue"
        >
          <img src="../../assets/img/client_Logo.png" alt="Logo" />
        </div>
      </div>
      <ul
        class="d-flex justify-content-end align-items-center flex-grow-1 py-0 px-2 my-0"
        role="list"
      >
        <li
          v-if="showselectstudy == true"
          class="px-1 px-md-2"
          aria-label="Change study"
          tabindex="0"
        >
          <select
            class="study-select"
            name="Select Study"
            v-model="valnow"
            @change.prevent="studychange($event.target.value)"
          >
            <option selected disabled value="">Select Study</option>

            <option
              v-for="studie in studies"
              :key="studie.studyId"
              :value="studie.studyId"
            >
              {{ studie.studyRef }}
            </option>
          </select>
        </li>
        <li
  class="px-1 add-study-popup cursor-pointer"
  aria-label="Default Settings"
  tabindex="0"
  @keydown.enter.prevent="DefaultSetupPopUp = true"
>
  <img
    class="px-md-1"
    src="../../assets/img/default_setup.png"
    alt="Default Settings"
    @click.prevent="DefaultSetupPopUp = true"
  />
  <div class="tool-tip">{{ $t("navigations.default preferences") }}</div>
</li>
        <li
          class="px-2 px-md-0 user-profile cursor-pointer"
          aria-label="User profile"
          tabindex="0"
        >
          <a
            class="user-block px-0"
            @click.prevent="displayProfile()"
            data-toggle="tooltip"
            data-placement="top"
          >
            <img
              :src="usersdetails.picture"
              class="img-fluid profile-pic"
              alt="User Profile Image"
            />
            <div class="tool-tip">
              {{ $t("navigations.user profile") }}
            </div>
          </a>
          <div class="profile-block animate fadeIn text-start">
            <div
              class="login-user-details d-flex justify-content-start align-items-center"
            >
              <div class="login-user-details--image">
                <img
                  class="profile-pic me-2"
                  :src="usersdetails.picture"
                  alt="User Image"
                />
              </div>
              <div class="login-user-details--details d-flex flex-column">
                <span
                  ><b>{{ usersdetails.given_name }}</b></span
                >
                <span>{{ usersdetails.name }}</span>
                <span v-if="currentRoleName">{{ currentRoleName }}</span>
              </div>
            </div>
            <div class="user-details d-flex flex-column">
              <div
                class="theme-change-block d-flex justify-content-start align-items-center"
                @click.prevent="$router.push('/profileSettings')"
              >
                <img
                  class="me-2"
                  src="../../assets/img/user_profile.png"
                  alt="User Profile"
                />
                <span>{{ $t("navigations.profile") }}</span>
              </div>
              <div
                class="theme-change-block d-flex justify-content-start align-items-center"
                @click="expandSidebar()"
              >
                <img
                  class="me-2"
                  src="../../assets/img/user_themes.png"
                  alt="User Themes"
                />
                <span class="theme-change-block">{{
                  $t("navigations.themes")
                }}</span>
                <div class="theme-menu animated fadeIn">
                  <div class="title">Themes</div>
                  <div
                    class="setings-item default-skin"
                    @click="switchTheme('theme-default')"
                  >
                    <span class="skin-name">
                      <a href="#" class="md-skin"> Default </a>
                    </span>
                  </div>
                  <div
                    class="setings-item teal-skin"
                    @click="switchTheme('theme-green')"
                  >
                    <span class="skin-name">
                      <a href="#" class="md-skin"> Teal Green </a>
                    </span>
                  </div>
                  <div
                    class="setings-item dusty-skin"
                    @click="switchTheme('theme-violet')"
                  >
                    <span class="skin-name">
                      <a href="#" class="md-skin"> Dusty Lavender </a>
                    </span>
                  </div>
                  <div
                    class="setings-item ocean-skin"
                    @click="switchTheme('theme-ocian')"
                  >
                    <span class="skin-name">
                      <a href="#" class="md-skin"> Ocean Green </a>
                    </span>
                  </div>
                  <div
                    class="setings-item stormy-skin"
                    @click="switchTheme('theme-stormy')"
                  >
                    <span class="skin-name">
                      <a href="#" class="md-skin"> Stormy Cloud </a>
                    </span>
                  </div>
                  <div
                    class="setings-item pastel-skin"
                    @click="switchTheme('theme-pastel')"
                  >
                    <span class="skin-name">
                      <a href="#" class="md-skin"> Pastel Russet </a>
                    </span>
                  </div>
                </div>
              </div>
              <span class="dropdown-divider"></span>
              <div
                class="theme-change-block d-flex justify-content-start align-items-center"
                @click.prevent="logout"
              >
                <img
                  class="me-2"
                  src="../../assets/img/logout.png"
                  alt="Logout"
                />
                <span>{{ $t("navigations.logout") }}</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </nav>
    <div id="wrapper">
      <nav
        v-if="showSideNavbar"
        id="mobilemenu"
        class="navbar-default navbar-static-side"
        role="navigation"
      >
        <div class="side-menu-min-height">
          <ul class="nav metismenu" id="side-menu">
            <!-- <li class="nav-header">
              <div class="dropdown profile-element mb-1">
                <img src="../../assets/img/IDSLogo.png" alt="Logo" />
              </div>
              <div class="logo-element">
                <img src="../../assets/img/IDS_small_Logo.png" alt="Logo" />
              </div>
            </li> -->
            <li class="main_hub_li">
              <router-link
                to="/landingPage"
                class="nav-link"
                @click.prevent="returnToLanding"
              >
                <span v-if="notcollapsed"
                  >{{ t("navigations.go to main hub") }}
                </span>
              </router-link>
            </li>
            <li
              v-if="
                rollsprivilages.includes('Mainmenu Home') &&
                isGenericMenu
              "
            >
              <router-link :to="'/' + defaultdashbord" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/home_n.png"
                  alt="Home Menu"
                />
                <span v-if="notcollapsed">{{ t("navigations.home") }} </span>
              </router-link>
            </li>
            <li
               v-if="
                rollsprivilages.includes('Mainmenu Data Entry') &&
                isGenericMenu
              "
            >
              <router-link :to="'/dataEntry'" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/data_entry_i.png"
                  alt="Data Entry Menu"
                />
                <span v-if="notcollapsed">{{ t("navigations.data entry") }} </span>
              </router-link>
            </li>
            <li v-if="getDefaultMenu == 'Stats'">
              <router-link
                to="/tocgenerate"
                class="nav-link"
                @click="close(); $store.dispatch('setVersion', 'Base')"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/analysis_tree.png"
                  alt="Analysis Menu"
                />

                <span v-if="notcollapsed">{{
                  t("navigations.analysis tree")
                }}</span>
              </router-link>
            </li>
            <li v-if="getDefaultMenu == 'Stats'">
              <router-link to="/analysisTreeQC" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/output_tree.png"
                  alt="Analysis tree for QC Menu"
                />
                <span v-if="notcollapsed">{{
                  t("navigations.analysis tree for stat qc")
                }}</span>
              </router-link>
            </li>
            <li v-if="getDefaultMenu == 'Stats'">
              <router-link to="/exportOutput" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/output_tree.png"
                  alt="Export Output Menu"
                />
                <span v-if="notcollapsed">{{
                  t("navigations.export output")
                }}</span>
              </router-link>
            </li>
            <li v-if="getDefaultMenu == 'Stats'">
              <router-link to="/tocgenerate" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/output_tree.png"
                  alt="Output Menu"
                />

                <span v-if="notcollapsed">{{
                  t("navigations.output tree")
                }}</span>
              </router-link>
            </li>
            <li v-if="getDefaultMenu == 'Stats'">
              <router-link to="/Macro_Management" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/macro_management.png"
                  alt="Macro Management Menu"
                />

                <span v-if="notcollapsed">{{ "Functions" }}</span>
              </router-link>
            </li>
             <li v-if="getDefaultMenu == 'Stats'">
              <router-link to="/shellgenerate" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/shells.svg"
                  alt="Shells Menu"
                />

                <span v-if="notcollapsed">{{ "Shells" }}</span>
              </router-link>
            </li>
            <li v-if="rollsprivilages.includes('ETMF Menu Dashboard') && getDefaultMenu == 'ETMF'">
              <router-link to="/etmfdashboard" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/study_list_n.png"
                  alt=""
                />

                <span v-if="notcollapsed">{{ "Dashboard" }}</span>
              </router-link>
            </li>
            <li v-if="rollsprivilages.includes('ETMF Menu My Task') && getDefaultMenu == 'ETMF'">
              <router-link to="/etmfuserdashboard" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/study_list_n.png"
                  alt=""
                />

                <span v-if="notcollapsed">{{ "My Task" }}</span>
              </router-link>
            </li>
            <li
              v-if="
                rollsprivilages.includes('ETMF Menu Artifact Explorer') &&
                getDefaultMenu == 'ETMF'
              "
            >
              <router-link to="/etmf" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/dashboards_n.png"
                  alt=""
                />

                <span v-if="notcollapsed">{{
                  $t("navigations.artifact explorer")
                }}</span>
              </router-link>
            </li>

            <li
              v-if="
                rollsprivilages.includes('ETMF Menu Approvals') &&
                getDefaultMenu == 'ETMF'
              "
            >
              <router-link to="/TmfDocReviewList" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/study_list_n.png"
                  alt=""
                />

                <span v-if="notcollapsed"
                  >{{ "Review List" }}
                  <!-- <sup v-if="pendingCounts.PendingReviewCount > 0" class="badge-pending">
                    {{ pendingCounts.PendingReviewCount }}
                  </sup> -->
                </span>
              </router-link>
            </li>
            <li
              v-if="
                rollsprivilages.includes('ETMF Menu Approvals') &&
                getDefaultMenu == 'ETMF'
              "
            >
              <router-link to="/TmfDocQcList" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/study_list_n.png"
                  alt=""
                />

                <span v-if="notcollapsed"
                  >{{ "QC List" }}
                  <!-- <sup v-if="pendingCounts.PendingQcCount > 0" class="badge-pending">
                    {{ pendingCounts.PendingQcCount }}
                  </sup> -->
                </span>
              </router-link>
            </li>
            <li
              v-if="
                rollsprivilages.includes('ETMF Menu Approvals') &&
                getDefaultMenu == 'ETMF'
              "
            >
              <router-link to="/etmfdoc" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/study_list_n.png"
                  alt=""
                />

                <span v-if="notcollapsed"
                  >{{ "Approvals" }}
                  <!-- <sup v-if="pendingCounts.pendingApprovalCount > 0" class="badge-pending">
                    {{ pendingCounts.pendingApprovalCount }}
                  </sup> -->
                </span>
              </router-link>
            </li>
            <li v-if="rollsprivilages.includes('ETMF Menu e-Sign') && getDefaultMenu == 'ETMF'">
              <router-link to="/signerslist" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/study_list_n.png"
                  alt=""
                />

                <span v-if="notcollapsed">{{ "e-Sign" }}</span>
              </router-link>
            </li>
            <li v-if="rollsprivilages.includes('ETMF Menu eTMF Report') && getDefaultMenu == 'ETMF'">
              <router-link to="/etmfreport" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/study_list_n.png"
                  alt=""
                />

                <span v-if="notcollapsed">eTMF Report</span>
              </router-link>
            </li>

            <li v-if="rollsprivilages.includes('ePRO ePRO Management') && getDefaultMenu == 'EPRO'">
              <router-link to="/epro" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/e_pro.png"
                  alt=""
                />

                <span v-if="notcollapsed">{{ "ePRO Management" }}</span>
              </router-link>
            </li>
            <li v-if="rollsprivilages.includes('ePRO ePRO Subjects') && getDefaultMenu == 'EPRO'">
              <router-link to="/eproSubjects" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/subjects.png"
                  alt=""
                />

                <span v-if="notcollapsed">{{ t("navigations.subjects") }}</span>
              </router-link>
            </li>
            <li v-if="getDefaultMenu == 'Stats'">
              <router-link to="/interimDataset" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/interim_data.png"
                  alt="Macro Management Menu"
                />

                <span v-if="notcollapsed">{{ "Interim Data Analysis" }}</span>
              </router-link>
            </li>
            <li v-if="getDefaultMenu == 'Stats'">
              <a
                href="#"
                @click.prevent="expandfun('reportsetup', 0, 'mainmenu')"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/Analysis_report.png"
                  alt="Report Menu" />
                <span class="nav-label">{{ "Analysis Report" }} </span>
                <span
                  class="fa fa-angle-left angle-down-right mt-1"
                  :class="{
                    'float-right': isActive,
                    'rotate-down': !mainmenu[0],
                  }"
                >
                </span
              ></a>
              <ul id="reportsetup" class="nav nav-second-level collapse">
                <li class="submenuitem">
                  <router-link to="/analysis_report" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/stats_report.png"
                      alt="All Key Metadata Menu"
                    />

                    <span v-if="notcollapsed">{{ "All Key Metadata" }}</span>
                  </router-link>
                </li>
                <li class="submenuitem">
                  <router-link to="/statqc_report" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/stats_report.png"
                      alt="Stat Qc Report Menu"
                    />

                    <span v-if="notcollapsed">{{ "Stat Qc Report" }}</span>
                  </router-link>
                </li>
                <li class="submenuitem">
                  <router-link to="/statusentry_report" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/stats_report.png"
                      alt="Current Status Entry Report Menu"
                    />

                    <span v-if="notcollapsed">{{ "Status Entry Report" }}</span>
                  </router-link>
                </li>
                <li class="submenuitem">
                  <router-link to="/programvalidation_report" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/stats_report.png"
                      alt="Program Validation Status Report Menu"
                    />

                    <span v-if="notcollapsed">{{
                      "Program Validation Report"
                    }}</span>
                  </router-link>
                </li>
                <li class="submenuitem">
                  <router-link to="/traceability_report" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/stats_report.png"
                      alt="Traceability Status Report Menu"
                    />

                    <span v-if="notcollapsed">{{ "Traceability Report" }}</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <!-- <li v-if="getDefaultMenu == 'Stats'">
              <router-link to="/scheduleTask" class="nav-link" @click.prevent="close"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/interim_data.png"
                  alt="Macro Management Menu"
                />
                
                <span v-if="notcollapsed">{{t("navigations.schedule task") }}</span>
              </router-link>
            </li> -->

            <!-- <li v-if="getDefaultMenu == 'Stats'">
              <router-link
                to="/filediffpage"
                class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/difference.png"
                  alt="Macro Management Menu"
                />

                <span v-if="notcollapsed">{{ "Diff Viewer" }}</span>
              </router-link>
            </li> -->
            <li
              v-if="
                rollsprivilages.includes('Mainmenu Study Insights') &&
                isGenericMenu
              "
            >
              <router-link to="/Site_Overview" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/study_insights.png"
                  alt="Upload Study Menu"
                />
                <span v-if="notcollapsed"
                  >{{ t("navigations.study insights") }}
                </span>
              </router-link>
            </li>
            <li
              v-if="
                rollsprivilages.includes('Mainmenu Protocol Data Import') &&
                isGenericMenu
              "
            >
              <router-link to="/uploadstudyprotocol" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/protocol_data_import.png"
                  alt="Upload Study Menu"
                />
                <span v-if="notcollapsed"
                  >{{ t("navigations.protocol data import") }}
                </span>
              </router-link>
            </li>
            <li
              v-if="
                rollsprivilages.includes('Mainmenu Import Study') &&
                isGenericMenu
              "
            >
              <router-link to="/importstudy" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/ImportStudy.png"
                  alt="Upload Study Menu"
                />
                <span v-if="notcollapsed"
                  >{{ t("navigations.import study") }}
                </span>
              </router-link>
            </li>
              <li
              v-if="
              rollsprivilages.includes('Mainmenu Protocol Extraction') &&
                isGenericMenu
              "
            >
              <router-link to="/soaextraction" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/protocol_extraction.png"
                  alt="Protocol Extraction Menu"
                />
                <span v-if="notcollapsed"
                  >{{ t("navigations.protocol extraction") }}
                </span>
              </router-link>
            </li>
            <li
              v-if="
              rollsprivilages.includes('Mainmenu Study Emulation') &&
                isGenericMenu
              "
            >
              <router-link to="/studyemulation" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/study_emulation.png"
                  alt="Study Emulation Menu"
                />
                <span v-if="notcollapsed"
                  >{{ t("navigations.study emulation") }}
                </span>
              </router-link>
            </li>
            
            <li
              v-if="
                rollsprivilages.includes('Mainmenu Subject Diaries') &&
                isGenericMenu
              "
            >
              <router-link to="/subjectdiaries" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/nurse_diary.svg"
                  alt="Subject Diaries"
                />
                <span v-if="notcollapsed">Subject Diaries </span>
              </router-link>
            </li>
            <li
              v-if="
              rollsprivilages.includes('Mainmenu MedDRA Coding') &&
                isGenericMenu
              "
            >
              <router-link to="/meddralistforms" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/medra_coding.png"
                  alt="MedDRA Coding"
                />
                <span v-if="notcollapsed">MedDRA Coding </span>
              </router-link>
            </li>
           <li
              v-if="
                rollsprivilages.includes('Mainmenu Research Subject') &&
                isGenericMenu
              "
            >
              <router-link to="/researchFhirSubject" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/Research_subject.png"
                  alt="Research Subject"
                />
                <span v-if="notcollapsed">Research Subject </span>
              </router-link>
            </li>  
           <!-- <li
              v-if="
                isGenericMenu
              "
            >
              <router-link to="/monitorDashboard" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/nurse_diary.svg"
                  alt="monitor dashboard"
                />
                <span v-if="notcollapsed">Monitor Dashboard </span>
              </router-link>
            </li>   -->
            <li
              v-if="
                rollsprivilages.includes('Mainmenu CRF Version Control') &&
                isGenericMenu
              "
            >
              <router-link to="/crfversioncontrol" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/crf_version_control.png"
                  alt="CRF Version Control"
                />
                <span v-if="notcollapsed">CRF Version Control </span>
              </router-link>
            </li> 
            <!-- <li v-if="
              rollsprivilages.includes('Mainmenu CtQ Registry') &&
              isGenericMenu 
            ">
              <router-link to="/ctqRegistry" class="nav-link"><img class="me-1 mb-1"
                  src="../../assets/img/ctq_registry.png" alt="CTQ" />
                <span v-if="notcollapsed">CtQ Registry </span>
              </router-link>
            </li> -->
             <li
              v-if="
                rollsprivilages.includes('Mainmenu CTQ') &&
                isGenericMenu
              "
 
            >
              <router-link to="/CtqByLevel" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/ctq_signal_review.png"
                  alt="CTQ"
                />
                <span v-if="notcollapsed">CTQ Signal Review </span>
              </router-link>
            </li> 
             
            <li
              v-if="
                rollsprivilages.includes('Mainmenu Study') &&
                isGenericMenu
              "
            >
              <a
                href="#"
                @click.prevent="expandfun('studysetup', 0, 'mainmenu')"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/study_n.png"
                  alt="Study Menu" />
                <span class="nav-label">{{ t("navigations.study") }} </span>
                <span
                  class="fa fa-angle-left angle-down-right mt-1"
                  :class="{
                    'float-right': isActive,
                    'rotate-down': !mainmenu[0],
                  }"
                >
                </span
              ></a>
              <ul id="studysetup" class="nav nav-second-level collapse">
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('Study Menu Study Profile')"
                >
                  <router-link to="/studyProfile" class="nav-link">
                    <img
                      class="me-1 mb-1"
                      src="../../assets/img/study_profile_n.png"
                      alt="study profile Menu"
                    />
                    <span v-if="notcollapsed"
                      >{{ t("navigations.study profile") }}
                    </span>
                  </router-link>
                </li>

                <li class="submenuitem"
                v-if="rollsprivilages.includes('Study Menu Review Study Version')">
                    <router-link to="/reviewStudyVersion" class="nav-link">
                      <img
                        class="me-1 mb-1"
                        src="../../assets/img/study_profile_n.png"
                        alt="Review Study Version"
                      />
                      <span v-if="notcollapsed"
                        >{{ t("navigations.review study version") }}
                      </span>
                    </router-link>
                </li>

                <li class="submenuitem"
                    v-if="rollsprivilages.includes('Study Menu Edit Checks')">
                    <router-link to="/customFieldRules" class="nav-link">
                      <img
                        class="me-1 mb-1"
                        src="../../assets/img/study_profile_n.png"
                        alt="Custom Field Rules"
                      />
                      <span v-if="notcollapsed"
                        >{{ t("navigations.edit checks") }}
                      </span>
                    </router-link>
                </li>

                <li
                  v-if="rollsprivilages.includes('Study Menu SoA')"
                  class="submenuitem"
                >
                  <router-link to="/soa" class="nav-link">
                    <img
                      class="me-1 mb-1"
                      src="../../assets/img/Soa.png"
                      alt="study profile Menu"
                    />
                    <span v-if="notcollapsed">SoA </span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('Study Menu SoA Change Visualization')"
                >
                  <router-link to="/studydiffviewer" class="nav-link">
                    <img
                      class="me-1 mb-1"
                      src="../../assets/img/Soa.png"
                      alt="study profile Menu"
                    />
                    <span v-if="notcollapsed">SoA Change Visualization </span>
                  </router-link>
                </li>
                   <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('Study Menu ICF')"
                >
                  <router-link to="/icflist" class="nav-link">
                    <img
                      class="me-1 mb-1"
                       src="../../assets/img/study_profile_n.png"
                      alt="study profile Menu"
                    />
                    <span v-if="notcollapsed">ICF </span>
                  </router-link>
                </li>
                <li
                  class="fullwidthquery"
                  @mouseleave="mouseItemLeave('itemsetup')"
                  v-if="rollsprivilages.includes('Study Menu Items')"
                >
                  <a
                    href="#"
                    class="fullwidthquery"
                    @click.prevent="expandfun('itemsetup', 0, 'submenu')"
                  >
                    <img
                      class="me-1 mb-1"
                      src="../../assets/img/Items_n.png"
                      alt="Item menu" />
                    <span class="nav-label"
                      >{{ t("navigations.study components") }} </span
                    ><span
                      class="fa fa-angle-left angle-down-right mt-1"
                      :class="{
                        'float-right': isActive,
                        'rotate-down': submenu[0] == true,
                      }"
                    ></span
                  ></a>
                  <ul
                    id="itemsetup"
                    class="nav nav-second-level collapse"
                    v-if="isActive"
                  >
                    <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Study Components Menu Form Summary'
                        )
                      "
                    >
                      <router-link to="/formSummary" class="nav-link">
                        <!-- <img class="me-1 mb-1 thirdlevel" src="../../assets/img/form_summary_n.png" alt="Form Summary Menu"/> -->
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.form summary") }}</span
                        >
                      </router-link>
                    </li>
                    <!-- <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Study Components Menu Soas'
                        )
                      "
                    >
                      <router-link to="/ArmVisitTree" class="nav-link">
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.soas") }}</span
                        >
                      </router-link>
                    </li> -->
                    <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Study Components Menu Cohort'
                        ) 
                      " 
                    >
                      <router-link to="/Cohort" class="nav-link">
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.Cohort") }}</span
                        >
                      </router-link>
                    </li>
                     <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Study Components Menu Arm'
                        ) 
                      " 
                    >
                      <router-link to="/ArmManagement" class="nav-link">
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.arm") }}</span
                        >
                      </router-link>
                    </li>
                    <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Study Components Menu Study Phases'
                        ) 
                      " 
                    >
                      <router-link to="/StudyPhaseManagement" class="nav-link">
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.study phases") }}</span
                        >
                      </router-link>
                    </li>
                    <li
                      class="submenuitem"
                       v-if="
                        rollsprivilages.includes(
                          'Study Components Menu Subject Milestones'
                        ) 
                      " 
                    >
                      <router-link to="/SubjectMilestone" class="nav-link">
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.subject milestones") }}</span
                        >
                      </router-link>
                    </li>
                     <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Study Components Menu Arm'
                        ) 
                      " 
                    >
                      <router-link to="/Cycles" class="nav-link">
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.cycles") }}</span
                        >
                      </router-link>
                    </li>
                    <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Study Components Menu Countries'
                        )
                      "
                    >
                      <router-link to="/StudyCountry" class="nav-link">
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.countries") }}</span
                        >
                      </router-link>
                    </li>
                    <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes('Study Components Menu Sites')
                      "
                    >
                      <router-link to="/sitelist" class="nav-link">
                        <!-- <img class="me-1 mb-1 thirdlevel" src="../../assets/img/sites_n.png" alt="Sites Menu"/> -->
                        <span class="me-1 mb-1 thirdlevel" v-if="notcollapsed"
                          >{{ t("navigations.sites") }}
                        </span>
                      </router-link>
                    </li>

                    <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Study Components Menu Subjects'
                        )
                      "
                    >
                      <router-link to="/patientlist" class="nav-link">
                        <!-- <img class="me-1 thirdlevel" src="../../assets/img/subject.png" alt="Subjects Menu"/> -->
                        <span class="me-1 mb-1 thirdlevel" v-if="notcollapsed"
                          >{{ t("navigations.subjects") }}
                        </span>
                      </router-link>
                    </li>
                    <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Study Components Menu E-Consent'
                        )
                      "
                    >
                      <router-link to="/eConsentList" class="nav-link">
                        <!-- <img class="me-1 thirdlevel" src="../../assets/img/subject.png" alt="Subjects Menu"/> -->
                        <span class="me-1 mb-1 thirdlevel" v-if="notcollapsed"
                          >{{ t("navigations.e-consent") }}
                        </span>
                      </router-link>
                    </li>
                    <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes('Study Components Menu Visits')
                      "
                    >
                      <router-link to="/visitlist" class="nav-link">
                        <!-- <img class="me-1 thirdlevel" src="../../assets/img/visits.png" alt="Visits Menu"/> -->
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.visits") }}</span
                        >
                      </router-link>
                    </li>
                    <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Study Components Menu Visit Templates'
                        )
                      "
                    >
                      <router-link to="/formTemplates" class="nav-link">
                        <!-- <img class="me-1 thirdlevel" src="../../assets/img/study_template.png" alt="Subjects Menu"/> -->
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.visit forms") }}</span
                        >
                      </router-link>
                    </li>
                    <!-- <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Study Components Menu CRF View'
                        )
                      "
                    >
                      <router-link
                        to="/crfView"
                        class="nav-link"
                      >
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >CRF translation view</span
                        >
                      </router-link>
                    </li> -->
                    <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Study Components Menu Submitted Forms'
                        )
                      "
                    >
                      <router-link to="/listform" class="nav-link">
                        <!-- <img class="me-1 thirdlevel" src="../../assets/img/forms.png" alt="Form Menu"/> -->
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.submitted forms") }}</span
                        >
                      </router-link>
                    </li>
                    <!-- <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Study Components Menu Submitted Forms'
                        )
                      "
                    >
                      <router-link
                        to="/meddralistforms"
                        class="nav-link"
                      >
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.meddra forms") }}</span
                        >
                      </router-link>
                    </li> -->
                    <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Study Components Menu Unassigned Form'
                        )
                      "
                    >
                      <router-link to="/displayform" class="nav-link">
                        <!-- <img class="me-1 thirdlevel" src="../../assets/img/assign-form.png" alt="Assign Form Menu"/> -->
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.unassigned forms") }}</span
                        >
                      </router-link>
                    </li>
                    <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Study Components Menu Partially Filled Forms'
                        )
                      "
                    >
                      <router-link to="/reviewFormList" class="nav-link">
                        <!-- <img class="me-1 thirdlevel" src="../../assets/img/assign_form.png" alt="Form Menu"/> -->
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.partially filled forms") }}</span
                        >
                      </router-link>
                    </li>
                    <li
                      class="submenuitem"
                      v-if="
                        !rollsprivilages ||
                        rollsprivilages.includes('Study Components Menu Users')
                      "
                    >
                      <router-link to="/StudyBasedUserList" class="nav-link">
                        <!-- <img class="me-1 thirdlevel" src="../../assets/img/users.png" alt="Users Menu"/> -->
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.users") }}</span
                        >
                      </router-link>
                    </li>
                    <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Study Components Menu Archived Forms'
                        )
                      "
                    >
                      <router-link to="/Archive" class="nav-link">
                        <!-- <img class="me-1 thirdlevel" src="../../assets/img/archive.png" alt="Form Menu"/> -->
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.archived forms") }}</span
                        >
                      </router-link>
                    </li>
                  </ul>
                </li>
                <!-- lab starts -->
                <li
                  class="fullwidthquery"
                  @mouseleave="mouseItemLeave('labs')"
                  v-if="rollsprivilages.includes('Study Menu Labs')"
                >
                  <a
                    href="#"
                    class="fullwidthquery"
                    @click.prevent="expandfun('labs', 1, 'submenu')"
                  >
                    <img
                      class="me-1"
                      src="../../assets/img/form_designer_n.png"
                      alt="Labs"
                    />
                    <span
                      class="fa fa-angle-left angle-down-right mt-1"
                      :class="{
                        'float-right': isActive,
                        'rotate-down': submenu[1] == true,
                      }"
                    >
                    </span>
                    <span class="nav-label">
                      {{ t("navigations.labs") }}
                    </span>
                  </a>
                  <ul
                    id="labs"
                    class="nav nav-second-level collapse"
                    v-if="isActive"
                  >
                    <li
                      class="submenuitem"
                      v-if="rollsprivilages.includes('Labs Menu Lab Master')"
                    >
                      <router-link to="/labs" class="nav-link">
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.labs") }}</span
                        >
                      </router-link>
                    </li>
                    <li
                      class="submenuitem"
                      v-if="rollsprivilages.includes('Labs Menu Lab Test')"
                    >
                      <router-link to="/labTest" class="nav-link">
                        <span class="me-1 mb-1 thirdlevel" v-if="notcollapsed">
                          {{ t("navigations.lab test") }}
                        </span>
                      </router-link>
                    </li>
                  </ul>
                </li>
                <!-- lab ends -->
                <!-- query test starts -->
                <li
                  class="fullwidthquery"
                  @mouseleave="mouseItemLeave('querysetup')"
                  v-if="rollsprivilages.includes('Study Menu Queries')"
                >
                  <a
                    href="#"
                    class="fullwidthquery"
                    @click.prevent="expandfun('querysetup', 2, 'submenu')"
                    ><img
                      class="me-1 mb-0"
                      src="../../assets/img/queries_n.png"
                      alt="QueryMenu" />
                    <span class="nav-label"
                      >{{ t("navigations.queries") }} </span
                    ><span
                      class="fa fa-angle-left angle-down-right mt-1"
                      :class="{
                        'float-right': isActive,
                        'rotate-down': submenu[2] == true,
                      }"
                    ></span
                  ></a>
                  <ul
                    id="querysetup"
                    class="nav nav-second-level collapse"
                    v-if="isActive"
                  >
                    <li
                      v-if="rollsprivilages.includes('Query Menu Sent')"
                      class="submenuitem"
                    >
                      <router-link to="/sentQueryList" class="nav-link">
                        <!-- <img class="me-1 thirdlevel" src="../../assets/img/sent_queries_n.png" alt="Sent Query Menu"/> -->
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.sent") }}</span
                        >
                      </router-link>
                    </li>
                    <li
                      v-if="rollsprivilages.includes('Query Menu Received')"
                      class="submenuitem"
                    >
                      <router-link to="/queryList" class="nav-link">
                        <!-- <img class="me-1 thirdlevel" src="../../assets/img/received_query_dark_n.png" alt="Received Query Menu" /> -->
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.received") }}</span
                        >
                      </router-link>
                    </li>
                    <li
                      v-if="rollsprivilages.includes('Query Menu All Queries')"
                      class="submenuitem"
                    >
                      <router-link to="/allQueryList" class="nav-link">
                        <!-- <img class="me-1 thirdlevel" src="../../assets/img/total_queries_n.png" alt="All Query Menu"/> -->
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.all queries") }}</span
                        >
                      </router-link>
                    </li>
                    <li
                      v-if="rollsprivilages.includes('Query Menu General')"
                      class="submenuitem"
                    >
                      <router-link to="/general_querylist" class="nav-link">
                        <!-- <img class="me-1 thirdlevel" src="../../assets/img/general_query_nav_n.png" alt="General Query Menu"/> -->
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.general") }}</span
                        >
                      </router-link>
                    </li>
                  </ul>
                </li>
                <!-- query test ends -->
                <li
                  class="fullwidthquery"
                  @mouseleave="mouseItemLeave('formdesignersetup')"
                  v-if="rollsprivilages.includes('Study Menu Form Designer')"
                >
                  <a
                    href="#"
                    class="fullwidthquery"
                    @click.prevent="
                      expandfun('formdesignersetup', 4, 'submenu')
                    "
                  >
                    <img
                      class="me-1"
                      src="../../assets/img/form_designer_n.png"
                      alt="Transfer"
                    />
                    <span
                      class="fa fa-angle-left angle-down-right mt-1"
                      :class="{
                        'float-right': isActive,
                        'rotate-down': submenu[4] == true,
                      }"
                    >
                    </span>
                    <span class="nav-label"
                      >{{ t("navigations.form designer") }}
                    </span>
                  </a>
                  <ul
                    id="formdesignersetup"
                    class="nav nav-second-level collapse"
                    v-if="isActive"
                  >
                    <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Form Designer Menu Designer Tool'
                        )
                      "
                    >
                      <router-link to="/formdesigner" class="nav-link">
                        <!-- <img class="me-1 thirdlevel" src="../../assets/img/designer_tool.svg" alt="Template Menu"/> -->
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.designer tool") }}</span
                        >
                      </router-link>
                    </li>

                    <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes('Form Designer Menu Templates')
                      "
                    >
                      <router-link to="/templatelist" class="nav-link">
                        <!-- <img class="me-1 thirdlevel" src="../../assets/img/designer_tool.svg" alt="Template Menu"/> -->
                        <span class="me-1 mb-1 thirdlevel" v-if="notcollapsed"
                          >{{ t("navigations.forms") }}
                        </span>
                      </router-link>
                    </li>
                    <li class="submenuitem">
                      <router-link to="/digitalform/approveforms" class="nav-link">
                          <span 
                              class="me-1 mb-1 thirdlevel" 
                              v-if="notcollapsed">Form Approval List 
                          </span>
                      </router-link>
                    </li>

                    <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Form Designer Menu Approve Template'
                        )
                      "
                    >
                      <router-link
                        to="/digitalform/approvelist"
                        class="nav-link"
                      >
                        <!-- <img class="me-1 thirdlevel" src="../../assets/img/designer_tool.svg" alt="Template Menu"/> -->
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.approve forms") }}</span
                        >
                      </router-link>
                    </li>
                  </ul>
                </li>
                <li
                  class="fullwidthquery"
                  @mouseleave="mouseItemLeave('studyadministrationsetup')"
                  v-if="
                    rollsprivilages.includes('Study Menu Study Administration')
                  "
                >
                  <a
                    href="#"
                    class="fullwidthquery"
                    @click.prevent="
                      expandfun('studyadministrationsetup', 3, 'submenu')
                    "
                  >
                    <img
                      class="me-1 mb-1"
                      src="../../assets/img/study_administration_n.png"
                      alt="Transfer"
                    />
                    <span
                      class="fa fa-angle-left angle-down-right mt-1"
                      :class="{
                        'float-right': isActive,
                        'rotate-down': submenu[3] == true,
                      }"
                    ></span>
                    <span class="nav-label"
                      >{{ t("navigations.study administration") }}
                    </span>
                  </a>
                  <ul
                    id="studyadministrationsetup"
                    class="nav nav-second-level collapse"
                    v-if="isActive"
                  >
                    <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Study Administration Menu Form Transfer'
                        )
                      "
                    >
                      <router-link to="/formtransfer" class="nav-link">
                        <!-- <img
                        class="me-1 thirdlevel"
                          src="../../assets/img/formtransfer.png"
                          alt="Transfer"
                        /> -->
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ $t("navigations.form transfer") }}</span
                        >
                      </router-link>
                    </li>
                    <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Study Administration Menu Subject Transfer'
                        )
                      "
                    >
                      <router-link to="/TransferSubject" class="nav-link">
                        <!-- <img
                          class="me-1 thirdlevel"
                          src="../../assets/img/patient_transfer.png"
                          alt="Transfer"
                        /> -->
                        <span class="me-1 mb-1 thirdlevel" v-if="notcollapsed"
                          >{{ $t("navigations.subject transfer") }}
                        </span>
                      </router-link>
                    </li>
                    <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Study Administration Menu Subject Schedule'
                        )
                      "
                    >
                      <router-link to="/PatientScheduleView" class="nav-link">
                        <!-- <img
                        class="me-1 thirdlevel"
                          src="../../assets/img/subject_schedule.png"
                          alt="Subject Schedule Menu"
                        /> -->
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.subject schedule") }}</span
                        >
                      </router-link>
                    </li>
                    <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Study Administration Menu Patient Login'
                        )
                      "
                    >
                      <router-link to="/patientLoginList" class="nav-link">
                        <!-- <img
                        class="me-1 thirdlevel"
                          src="../../assets/img/Patient_login.png"
                          alt="Subjects Login Menu"
                        /> -->
                        <span class="me-1 mb-1 thirdlevel" v-if="notcollapsed"
                          >{{ t("navigations.patient login") }}
                        </span>
                      </router-link>
                    </li>
                    <li
                      class="submenuitem"
                      v-if="
                        !rollsprivilages ||
                        rollsprivilages.includes(
                          'Study Administration Menu Unscheduled Visits'
                        )
                      "
                    >
                      <router-link to="/unscheduledvisits" class="nav-link">
                        <!-- <img
                    class="me-1 thirdlevel"
                      src="../../assets/img/unscheduled_visits.png"
                      alt="Unscheduled Visits Menu"
                    /> -->
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.unscheduled visits") }}</span
                        >
                      </router-link>
                    </li>
                    <li
                      class="submenuitem"
                      v-if="
                        !rollsprivilages ||
                        rollsprivilages.includes(
                          'Study Administration Menu Study Master Settings'
                        )
                      "
                    >
                      <router-link to="/StudystatusMaster" class="nav-link">
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.study master settings") }}</span
                        >
                      </router-link>
                    </li>
                    <li
                      class="submenuitem"
                      v-if="
                        rollsprivilages.includes(
                          'Study Administration Menu Change Schedule Template'
                        )
                      "
                    >
                      <router-link to="/visittemplate" class="nav-link">
                        <!-- <img
                      class="me-1 thirdlevel"
                      src="../../assets/img/visits_templates.png"
                      alt="Visit Templates Menu"
                    /> -->
                        <span
                          class="me-1 mb-1 thirdlevel"
                          v-if="notcollapsed"
                          >{{ t("navigations.change schedule form") }}</span
                        >
                      </router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <!--  -->
           
            <!--  -->
            <!--  -->
            <li
             v-if="
                getDefaultMenu == 'CTMS' && rollsprivilages.includes('CTMS Dashboard')
              "
            >
              <router-link to="/CTMS_Dashboard" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/nurse_diary.svg"
                  alt="CTMS_Dashboard"
                />
                <span v-if="notcollapsed">Dashboard </span>
              </router-link>
            </li>
            <li
              class="submenuitem"
              v-if="
                rollsprivilages.includes('CTMS CRA Visit Management') &&
                getDefaultMenu == 'CTMS'
              "
            >
            <a href="#" @click.prevent="expandfun('cramenu', 0, 'mainmenu')"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/iot_n.svg"
                  alt="Home Menu" />
                <span class="nav-label">{{ t("navigations.CRA Visit management") }} </span
                ><span
                  class="fa fa-angle-left angle-down-right mt-1"
                  :class="{
                    'float-right': isActive,
                    'rotate-down': !mainmenu[2],
                  }"
                ></span
              ></a>
              <ul id="cramenu" class="nav nav-second-level collapse">
                <li
                  class="submenuitem"
                v-if="rollsprivilages.includes('CRA Visit management Visit Prediction Dashboard')"
                  >
                <router-link to="/visitpredictiondashboard" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/sd_verification.png"
                  alt="Submit Form Menu"
                />
                <span v-if="notcollapsed">{{ t("navigations.visit prediction dashboard") }} </span>
                </router-link>
                </li>
                 <li
                  class="submenuitem"
                v-if="rollsprivilages.includes('CRA Visit management KPI List')"
                  >
                <router-link to="/kpilist" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/sd_verification.png"
                  alt="Submit Form Menu"
                />
                <span v-if="notcollapsed">{{ t("navigations.site overview") }} </span>
                </router-link>
                </li>
                <li
                  class="submenuitem"
                v-if="rollsprivilages.includes('CRA Visit management CRA Dashboard')"
                  >
                <router-link to="/cradashboard" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/sd_verification.png"
                  alt="Submit Form Menu"
                />
                <span v-if="notcollapsed">{{ t("navigations.cra dashboard") }} </span>
               </router-link>
                </li>
                <!-- <li
                  class="submenuitem" 
                v-if="rollsprivilages.includes('CRA CRA Management')"
                  >
                <router-link to="/cralist" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/sd_verification.png"
                  alt="Submit Form Menu" 
                />
                <span v-if="notcollapsed">{{ t("navigations.cra management") }} </span>
               </router-link>
                </li> -->
                     <li
                  class="submenuitem" 
                  v-if="rollsprivilages.includes('CRA Visit management My Schedule')"
                  >
                <router-link to="/crascheduellist" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/sd_verification.png"
                  alt="Submit Form Menu" 
                />
                <span v-if="notcollapsed">{{ t("navigations.My Schedule") }} </span>
               </router-link>
                </li>
                <li
                  class="submenuitem" 
                  v-if="rollsprivilages.includes('CRA Visit management Issue List')"
                  >
                <router-link to="/craissuelist" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/sd_verification.png"
                  alt="Submit Form Menu" 
                />
                <span v-if="notcollapsed">{{ t("navigations.issue list") }} </span>
               </router-link>
                </li>
                 <li
                  class="submenuitem" 
                  v-if="rollsprivilages.includes('CRA Visit management Checklist Configuration')"
                  >
                <router-link to="/crachecklistconfig" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/sd_verification.png"
                  alt="Submit Form Menu" 
                />
                <span v-if="notcollapsed">{{ t("navigations.checklist configuration") }} </span>
               </router-link>
                </li>
                <li
                  class="submenuitem" 
                  v-if="rollsprivilages.includes('CRA Visit management Visit Assignments')"
                  >
                <router-link to="/schedulelist" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/sd_verification.png"
                  alt="Submit Form Menu" 
                />
                <span v-if="notcollapsed">{{ t("navigations.Visit Assignments") }} </span>
               </router-link>
                </li>
              </ul>
               
            </li>
            <li
              class="submenuitem"
              v-if="
                rollsprivilages.includes('CTMS Monitoring Analytics') &&
                getDefaultMenu == 'CTMS'
              "
            >
            <a href="#" @click.prevent="expandfun('cradtamenu', 0, 'mainmenu')"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/iot_n.svg"
                  alt="Home Menu" />
                <span class="nav-label">Monitoring Analytics </span
                ><span
                  class="fa fa-angle-left angle-down-right mt-1"
                  :class="{
                    'float-right': isActive,
                    'rotate-down': !mainmenu[2],
                  }"
                ></span
              ></a>
              <ul id="cradtamenu" class="nav nav-second-level collapse">
                <li
                  class="submenuitem"  v-if="
                rollsprivilages.includes('Monitoring Analytics RACT Insights')
              "
                  >
                <router-link to="/RAC_Insight" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/sd_verification.png"
                  alt="Submit Form Menu"
                />
                <span v-if="notcollapsed">RACT Insight </span>
              </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="
                rollsprivilages.includes('Monitoring Analytics Data Signal Overview')"
                  >
                <router-link to="/dataSignalOverview" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/sd_verification.png"
                  alt="Submit Form Menu"
                />
                <span v-if="notcollapsed">Data Signal Overview </span>
                </router-link>
                </li>
              </ul>
               
            </li>

             <li
             v-if="
                rollsprivilages.includes('CTMS Centralized Study Portfolio') &&
                getDefaultMenu == 'CTMS'
              "
            >
              <router-link to="/datadashboard" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/nurse_diary.svg"
                  alt="centralised dashboard"
                />
                <span v-if="notcollapsed">Centralised Study Portfolio </span>
              </router-link>
            </li>
            <li
             v-if="
             rollsprivilages.includes('CTMS Site Overview') &&
                getDefaultMenu == 'CTMS'
              "
            >
              <router-link to="/Site_Overview" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/nurse_diary.svg"
                  alt="Site_Overview"
                />
                <span v-if="notcollapsed">{{ t("navigations.site overview") }} </span>
              </router-link>
            </li> 
            <li
             v-if="
                rollsprivilages.includes('CTMS Sites') &&
                getDefaultMenu == 'CTMS'
              "
            >
              <router-link to="/sitelist" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/nurse_diary.svg"
                  alt="Research Subject"
                />
                <span>{{ t("navigations.sites") }} </span>
              </router-link>
            </li> 
            <li
             v-if="
                rollsprivilages.includes('CTMS Subjects') &&
                getDefaultMenu == 'CTMS'
              "
            >
              <router-link to="/patientlist" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/nurse_diary.svg"
                  alt="Research Subject"
                />
                <span>{{ t("navigations.subjects") }} </span>
              </router-link>
            </li> 
            <li class="submenuitem" v-if="
              rollsprivilages.includes('CTMS SDV') &&
              getDefaultMenu == 'CTMS'
            ">
              <a href="#" @click.prevent="expandfun('sdvmenu', 3, 'mainmenu')"><img class="me-1 mb-1"
                  src="../../assets/img/sd_verification.png" alt="SDV Menu" />
                <span class="nav-label">{{ t("navigations.sdv") }} </span><span
                  class="fa fa-angle-left angle-down-right mt-1" :class="{
                    'float-right': isActive,
                    'rotate-down': !mainmenu[3],
                  }"></span></a>
              <ul id="sdvmenu" class="nav nav-second-level collapse">
                <li class="submenuitem" v-if="rollsprivilages.includes('SDV Summary')">
                  <router-link to="/sdvSummary" class="nav-link"><img class="me-1 mb-1"
                      src="../../assets/img/sd_verification.png" alt="Submit Form Menu" />
                    <span v-if="notcollapsed">{{ t("navigations.sdvSummary") }} </span>
                  </router-link>
                </li>
                <li class="submenuitem" v-if="rollsprivilages.includes('SDV Plan')">
                  <router-link to="/sdvPlan" class="nav-link"><img class="me-1 mb-1"
                      src="../../assets/img/sd_verification.png" alt="Submit Form Menu" />
                    <span v-if="notcollapsed">{{ t("navigations.sdvPlan") }} </span>
                  </router-link>
                </li>
              </ul>
            </li>
            <!-- <li
              class="submenuitem"
              v-if="
                // rollsprivilages.includes('Mainmenu Study') &&
                getDefaultMenu != 'Analytical' &&
                getDefaultMenu != 'AI/Ml' &&
                getDefaultMenu != 'EPRO' &&
                getDefaultMenu != 'Clinical' &&
                getDefaultMenu != 'Stats' &&
                getDefaultMenu != 'ETMF' &&
                getDefaultMenu != 'alerts'
              "
            >
              <router-link to="/kpilist" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/sd_verification.png"
                  alt="Submit Form Menu"
                />
                <span v-if="notcollapsed">{{ t("navigations.kpis") }} </span>
              </router-link>
            </li> -->
            <!--  -->
            <li
              v-if="
                rollsprivilages.includes(
                  'Main Hub Predictive Analytics Module'
                ) && getDefaultMenu == 'AI/Ml'
              "
            >
              <a href="#" @click.prevent="expandfun('aiscreen', 5, 'mainmenu')"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/ai_ml.png"
                  alt="Home Menu" />
                <span class="nav-label">{{
                  t("navigations.predictive analytics module")
                }}</span
                ><span
                  class="fa fa-angle-left angle-down-right mt-1"
                  :class="{
                    'float-right': isActive,
                    'rotate-down': !mainmenu[5],
                  }"
                ></span
              ></a>
              <ul id="aiscreen" class="nav nav-second-level collapse">
                <li
                  class="submenuitem"
                  v-if="
                    rollsprivilages.includes(
                      'Predictive Analytics Module Patient Screening'
                    )
                  "
                >
                  <router-link to="/PatientScreeningReport" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/patient_screening_n.png"
                      alt="Submit Form Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.subject screening")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="
                    rollsprivilages.includes(
                      'Predictive Analytics Module Patient Retention'
                    )
                  "
                >
                  <router-link to="/patientRetention" class="nav-link"
                    ><img
                      class="me-1"
                      src="../../assets/img/patient_retention_n.png"
                      alt="Patient retention "
                    />
                    <span v-if="notcollapsed"
                      >{{ t("navigations.subject retention") }}
                    </span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li
              v-if="
                rollsprivilages.includes('Mainmenu Study Data Analysis') &&
                getDefaultMenu == 'AI/Ml'
              "
              class="fullwidthquery"
              @mouseleave="mouseItemLeave('patentsurvival')"
            >
              <a
                href="#"
                @click.prevent="expandfun('patentsurvival', 6, 'mainmenu')"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/Study_data_analysis.png"
                  alt="StudyData" />
                <span class="nav-label"
                  >{{ t("navigations.study data analysis") }} </span
                ><span
                  class="fa fa-angle-left angle-down-right mt-1"
                  :class="{
                    'float-right': isActive,
                    'rotate-down': !mainmenu[6],
                  }"
                ></span
              ></a>
              <ul
                id="patentsurvival"
                class="nav nav-second-level collapse"
                v-if="isActive"
              >
                <li
                  class="submenuitem"
                  v-if="
                    rollsprivilages.includes(
                      'Study Data Analysis Survival Analysis'
                    )
                  "
                >
                  <router-link to="/survivalreport" class="nav-link">
                    <img
                      class="me-1"
                      src="../../assets/img/Survival_Analysis_n.png"
                      alt="Sent Query Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.survival analysis")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="
                    rollsprivilages.includes(
                      'Study Data Analysis Descriptive Statistic Report'
                    )
                  "
                >
                  <router-link to="/DescriptiveStatisticReport" class="nav-link"
                    ><img
                      class="me-1"
                      src="../../assets/img/Desc_Statistic_Report_n.png"
                      alt="Submit Form Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.descriptive statistic report")
                    }}</span>
                  </router-link>
                </li>
                <!-- <li
                      class="submenuitem"
                    >
                      <router-link to="/aereport" class="nav-link" @click.prevent="close"
                        ><i class="fa fa-bed mr-2" aria-hidden="true"></i>

                        <span v-if="notcollapsed">Adverse Events  </span>
                      </router-link>
                    </li>  -->
                <!-- <li
                      class="submenuitem"
                    >
                      <router-link to="/deathsummaryreport" class="nav-link" @click.prevent="close"
                        ><i class="fa fa-bomb mr-2" aria-hidden="true"></i>

                        <span v-if="notcollapsed">Death Summary Report  </span>
                      </router-link>
                    </li>  -->
                <!-- <li
                      class="submenuitem"
                    >
                      <router-link to="/labsummaryreport" class="nav-link" @click.prevent="close"
                        ><i class="fa fa-thermometer-three-quarters mr-2" aria-hidden="true"></i>

                        <span v-if="notcollapsed">Lab Summary Report  </span>
                      </router-link>
                    </li>  -->
                <!-- <li
                      class="submenuitem"
                    >
                      <router-link to="/subjectstatusreport" class="nav-link" @click.prevent="close"
                        ><i class="fa fa-thermometer-three-quarters mr-2" aria-hidden="true"></i>

                        <span v-if="notcollapsed">{{ t("navigations.subject status report") }}</span>
                      </router-link>
                    </li>  -->
                <!-- <li
                      class="submenuitem"
                    >
                      <router-link to="/medicalhistory" class="nav-link" @click.prevent="close"
                        ><i class="fa fa-stethoscope mr-2" aria-hidden="true"></i>

                        <span v-if="notcollapsed">Medical History Report  </span>
                      </router-link>
                    </li>  -->
                <!-- <li
                      class="submenuitem"
                    >
                      <router-link to="/labresultreview" class="nav-link" @click.prevent="close"
                        ><i class="fa fa-flask mr-2" aria-hidden="true"></i>

                        <span v-if="notcollapsed">Lab Result Review Report  </span>
                      </router-link>
                    </li>  -->
                <!-- <li
                      class="submenuitem"
                    >
                      <router-link to="/vitalsignreport" class="nav-link" @click.prevent="close"
                        ><i class="fa fa-heartbeat mr-2" aria-hidden="true"></i>

                        <span v-if="notcollapsed">Vital sign Result trends  </span>
                      </router-link>
                    </li> -->
                <!-- <li class="submenuitem">
                      <router-link to="/demographicReport" class="nav-link" @click.prevent="close"
                        ><i class="fa fa-heartbeat mr-2" aria-hidden="true"></i>

                        <span v-if="notcollapsed">Demographics Summary Report </span>
                      </router-link>
                    </li> -->
              </ul>
            </li>
            <li
              class="submenuitem"
              v-if="
                rollsprivilages.includes('Mainmenu FHIR Data View') &&
                isGenericMenu
              "
            >
              <router-link to="/fhirViewer" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/fillform_n.png"
                  alt="Submit Form Menu"
                />
                <span v-if="notcollapsed"
                  >{{ t("navigations.fhirViewer") }}
                </span>
              </router-link>
            </li>
            <li
              class="submenuitem"
              v-if="
                rollsprivilages.includes('Mainmenu Subject Schedule') &&
                isGenericMenu
              "
            >
              <router-link to="/subject_schedule" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/subject_schedule_new.png"
                  alt="Submit Form Menu"
                />
                <span v-if="notcollapsed"
                  >{{ t("navigations.subject schedule") }}
                </span>
              </router-link>
            </li>
            <li
              class="submenuitem"
              v-if="
                rollsprivilages.includes('Mainmenu Form Indexing') &&
                isGenericMenu
              "
            >
              <router-link to="/formindex" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/form_indexing.png"
                  alt="Submit Form Menu"
                />
                <span v-if="notcollapsed"
                  >{{ t("navigations.form index") }}
                </span>
              </router-link>
            </li>
            <li
              class="submenuitem"
              v-if="
                rollsprivilages.includes('Mainmenu Fill Form') &&
                isGenericMenu
              "
            >
              <router-link to="/submitForm" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/fillform_n.png"
                  alt="Submit Form Menu"
                />
                <span v-if="notcollapsed"
                  >{{ t("navigations.fill form") }}
                </span>
              </router-link>
            </li>
            <li
              v-if="
                rollsprivilages.includes('Mainmenu SDTM Conversion') &&
                isGenericMenu
              "
            >
              <router-link to="/sdtm" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/upload_study_protocol.png"
                  alt="SDTM conversion"
                />
                <span v-if="notcollapsed"
                  >{{ t("navigations.sdtm conversion") }}
                </span>
              </router-link>
            </li>
            <li
              class="submenuitem"
              v-if="
                rollsprivilages.includes('Mainmenu Study List') &&
                isGenericMenu
              "
            >
              <router-link to="/studylist" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/study_list_n.png"
                  alt="Study Menu"
                />
                <span v-if="notcollapsed">{{
                  t("navigations.study list")
                }}</span>
              </router-link>
            </li>
            <li class="submenuitem" v-if="getDefaultMenu == 'Analytical'">
              <router-link to="/analyticalDashboard" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/analytical_dashboard.svg"
                  alt="Visit Summary Menu"
                />
                <span v-if="notcollapsed">
                  {{ t("navigations.analytical dashboards") }}
                </span>
              </router-link>
            </li>
            <li         
                class="submenuitem" v-if="getDefaultMenu == 'Clinical' && rollsprivilages.includes('RBQM Site Risk Dashboard')">
              <router-link to="/siteRiskDashboard" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/analytical_dashboard.svg"
                  alt="Visit Summary Menu"
                />
                <span v-if="notcollapsed">
                  {{ t("navigations.site risk dashboard") }}
                </span>
              </router-link>
            </li>
            <li v-if="getDefaultMenu == 'Clinical'">
              <a
                href="#"
                @click.prevent="expandfun('dashboardmenu', 7, 'mainmenu')"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/riskBasedMonitoring.svg"
                  alt="Risk Based Monitoring Menu" />
                <span class="nav-label">{{ t("navigations.rbqm") }} </span
                ><span
                  class="fa fa-angle-left angle-down-right mt-1"
                  :class="{
                    'float-right': isActive,
                    'rotate-down': !mainmenu[7],
                  }"
                ></span
              ></a>
              <ul id="dashboardmenu" class="nav nav-second-level collapse">
                <!-- <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('RBQM Risk Summary')"
                >
                  <router-link
                    @click="mainmenu[7] = true"
                    to="/InteligentDashboard"
                    class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/ract-import.png"
                      alt="RBQM_Dashboard"
                    />
                    <span v-if="notcollapsed">Historical Dashboard</span>
                  </router-link>
                </li> -->
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('RBQM Baseline Comparison')"
                >
                  <router-link
                    @click="mainmenu[7] = true"
                    to="/baseline_comparison"
                    class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/ract-import.png"
                      alt="baseline_comparison"
                    />
                    <span v-if="notcollapsed">Baseline Comparison</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('RBQM CTQ Registry')"
                >
                  <router-link
                    @click="mainmenu[7] = true"
                    to="/ctqRegistry"
                    class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/ract-import.png"
                      alt="baseline_comparison"
                    />
                    <span v-if="notcollapsed">CTQ Registry</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('RBQM Risk Registry')"
                >
                  <router-link
                    @click="mainmenu[7] = true"
                    to="/riskRegistry"
                    class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/ract-import.png"
                      alt="baseline_comparison"
                    />
                    <span v-if="notcollapsed">Risk Registry</span>
                  </router-link>
                </li>
                 <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('RBQM KRI Registry')"
                >
                  <router-link
                    @click="mainmenu[7] = true"
                    to="/kriRegistry"
                    class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/ract-import.png"
                      alt="baseline_comparison"
                    />
                    <span v-if="notcollapsed">KRI Registry</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('RBQM Risk Summary')"
                >
                  <router-link
                    @click="mainmenu[7] = true"
                    to="/RBQM_Dashboard"
                    class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/ract-import.png"
                      alt="RBQM_Dashboard"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.risk summary")
                    }}</span>
                  </router-link>
                </li>
                <!-- <li class="submenuitem" v-if="rollsprivilages.includes('RBQM Dashboard')">
                  <router-link
                    to="/riskSummary"
                    class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/ract-import.png"
                      alt="riskSummary"
                    />
                    <span v-if="notcollapsed">{{ t('navigations.rbqm dashboard') }}</span>
                  </router-link>
                </li> -->
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('RBQM Critical Process')"
                >
                  <router-link to="/criticalDataInventory" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/ract-import.png"
                      alt=""
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.critical process")
                    }}</span>
                  </router-link>
                </li>
                <!-- <li class="submenuitem" v-if="rollsprivilages.includes('RBQM Query')">
                  <router-link
                    to="/RiskBasedMonitoring"
                    class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/query_monitoring.png"
                      alt="Query Menu"
                    />
                    <span v-if="notcollapsed">{{
                      $t("navigations.query")
                    }}</span>
                  </router-link>
                </li>
                <li class="submenuitem" v-if="rollsprivilages.includes('RBQM AE/SAE')">
                  <router-link
                    to="/ClinicalSafetyDashboard"
                    class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/AE_monitoring.png"
                      alt="Query Menu"
                    />
                    <span v-if="notcollapsed">AE/SAE</span>
                  </router-link>
                </li> -->
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('RBQM Key Risk Indicator')"
                >
                  <router-link to="/RactFileImport" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/ract-import.png"
                      alt=""
                    />
                    <span v-if="notcollapsed">{{ t("navigations.kri") }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('RBQM RACT Tool')"
                >
                  <router-link to="/ractTool" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/ract-import.png"
                      alt=""
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.ract tool")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('RBQM Dashboard')"
                >
                  <router-link to="/rbqmreport" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/ract-import.png"
                      alt=""
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.rbqm dashboard")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('RBQM Issue Log')"
                >
                  <router-link to="/riskRegister" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/ract-import.png"
                      alt=""
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.issue log")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('RBQM Site Level KRI Summary')"
                >
                  <router-link
                    @click="mainmenu[7] = true"
                    to="/rbqmstudyspecreport"
                    class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/ract-import.png"
                      alt="RBQM_Dashboard"
                    />
                    <span v-if="notcollapsed">{{ t("navigations.site level kri summary") }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('RBQM Threshold Management')"
                >
                  <router-link
                    @click="mainmenu[7] = true"
                    to="/rbqmthresholdmanagement"
                    class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/ract-import.png"
                      alt="RBQM_Dashboard"
                    />
                    <span v-if="notcollapsed">{{ t("navigations.threshold management") }}</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="submenuitem" v-if="getDefaultMenu == 'Clinical' && rollsprivilages.includes('RBQM Study Monitoring')">
              <router-link to="/studymonitoring" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/analytical_dashboard.svg"
                  alt="Visit Summary Menu"
                />
                <span v-if="notcollapsed">
                  {{ t("navigations.study monitoring") }}
                </span>
              </router-link>
            </li>
            <li
              v-if="
                getDefaultMenu == 'Clinical' &&
                rollsprivilages.includes('Data Monitoring')
              "
            >
              <a
                href="#"
                @click.prevent="expandfun('datamonitoring', 8, 'mainmenu')"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/riskBasedMonitoring.svg"
                  alt="data monitoring" />
                <span class="nav-label"
                  >{{ t("navigations.data monitoring") }} </span
                ><span
                  class="fa fa-angle-left angle-down-right mt-1"
                  :class="{
                    'float-right': isActive,
                    'rotate-down': !mainmenu[8],
                  }"
                ></span
              ></a>
              <ul id="datamonitoring" class="nav nav-second-level collapse">
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('Data Monitoring AE/SAE')"
                >
                  <router-link
                    @click="mainmenu[8] = true"
                    to="/aesaemonitoring"
                    class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/ract-import.png"
                      alt="aE/SAE monitoring"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.ae/sae")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="
                    rollsprivilages.includes('Data Monitoring Data Signals')
                  "
                >
                  <router-link
                    @click="mainmenu[8] = true"
                    to="/datasignal"
                    class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/ract-import.png"
                      alt="data signals"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.data signals")
                    }}</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <!-- <li class="submenuitem" v-if="getDefaultMenu == 'Clinical'">
              <router-link to="/RiskBasedMonitoring" class="nav-link" @click.prevent="close"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/riskBasedMonitoring.svg"
                  alt="Visit Summary Menu"
                />
                <span v-if="notcollapsed">
                  {{ t("navigations.RiskBasedMonitoring") }}
                </span>
              </router-link>
            </li> -->

            <!-- study setup menu ends -->
            <li
              v-if="
                rollsprivilages.includes('Mainmenu Dashboard') &&
                isGenericMenu
              "
            >
              <a
                href="#"
                @click.prevent="expandfun('dashboardmenu', 1, 'mainmenu')"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/dashboards_n.png"
                  alt="Home Menu" />
                <span class="nav-label">{{ t("navigations.dashboards") }} </span
                ><span
                  class="fa fa-angle-left angle-down-right mt-1"
                  :class="{
                    'float-right': isActive,
                    'rotate-down': !mainmenu[1],
                  }"
                ></span
              ></a>
              <ul id="dashboardmenu" class="nav nav-second-level collapse">
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('Dashboard Dynamic Dashboard')"
                >
                  <router-link to="/dynamicdashboard" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/dashboard.svg"
                      alt="Home Menu"
                    />
                    <span v-if="notcollapsed">{{
                      $t("navigations.dashboard")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('Dashboard Main Dashboard')"
                >
                  <router-link to="/home" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/main_dashboard.svg"
                      alt="Home Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.main dashboard")
                    }}</span>
                  </router-link>
                </li>

                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('Dashboard Nurse Dashboard')"
                >
                  <router-link to="/nursesummary" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/nurse_dashboard.svg"
                      alt="Nurse summary Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.nurse dashboard")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('Dashboard Site User Dashboard')"
                >
                  <router-link to="/siteuserdashboard" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/nurse_dashboard.svg"
                      alt="Nurse summary Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.site user dashboard")
                    }}</span>
                  </router-link>
                </li>
                   <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('Dashboard Consent Dashboard')"
                >
                  <router-link to="/eConsentDashboard" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/nurse_dashboard.svg"
                      alt="Nurse summary Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.consent dashboard")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('Dashboard Safety Report Dashboard')"
                >
                  <router-link to="/safetyreportdashboard" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/nurse_dashboard.svg"
                      alt="Nurse summary Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.safety report dashboard")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('Dashboard Subject Dashboard')"
                >
                  <router-link to="/subjectdashboard" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/nurse_dashboard.svg"
                      alt="subject dashboard Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.subject dashboard")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('Dashboard Study Summary')"
                >
                  <router-link to="/studysummary" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/study_summary.svg"
                      alt="Study Summary Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.study summary")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('Dashboard Site Summary')"
                >
                  <router-link to="/sitesummary" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/site_summary.svg"
                      alt="Site Summary Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.site summary")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('Dashboard Visit Summary')"
                >
                  <router-link to="/visitsummary" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/visit_summary.svg"
                      alt="Visit Summary Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.visit summary")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('Dashboard Nurse Diary')"
                >
                  <router-link to="/nursediary" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/nurse_diary.svg"
                      alt="Visit Summary Menu"
                    />
                    <span v-if="notcollapsed">
                      {{ t("navigations.nurse diary") }}
                    </span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li
              class="submenuitem"
              v-if="
                rollsprivilages.includes('Mainmenu Reports') &&
                isGenericMenu
              "
            >
              <a
                href="#"
                class="fullwidthquery"
                @click.prevent="expandfun('reportsitem', 2, 'submenu')"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/reports_n.png"
                  alt="Reports Menu" />
                <span class="nav-label">{{ t("navigations.reports") }} </span
                ><span
                  class="fa fa-angle-left angle-down-right mt-1"
                  :class="{
                    'float-right': isActive,
                    'rotate-down': submenu[2] == true,
                  }"
                ></span
              ></a>
              <ul id="reportsitem" class="nav nav-second-level collapse">
                <li
                  v-if="
                    rollsprivilages.includes('Reports Menu Report Dashboard')
                  "
                  class="submenuitem"
                >
                  <router-link to="/reportdashboard" class="nav-link">
                    <img
                      class="me-1 thirdlevel"
                      src="../../assets/img/reports.png"
                      alt="Reports Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.report dashboard")
                    }}</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li
              class="submenuitem"
              v-if="
                rollsprivilages.includes('Mainmenu Activity Graph') &&
                isGenericMenu
              "
            >
              <router-link to="/activitygraph" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/activity_graph.png"
                  alt="activitygraph"
                />
                <span v-if="notcollapsed">Activity Graph</span>
              </router-link>
            </li>
            <li
              class="submenuitem"
              v-if="
                rollsprivilages.includes('Mainmenu Graph') &&
                isGenericMenu
              "
            >
              <router-link to="/graphvisual" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/graph.png"
                  alt="graph"
                />
                <span v-if="notcollapsed">Graph</span>
              </router-link>
            </li>
            <!-- <li
              class="submenuitem"
              v-if="
                rollsprivilages.includes('Mainmenu Data Export') &&
                getDefaultMenu != 'Analytical' &&
                getDefaultMenu != 'AI/Ml' &&
                getDefaultMenu != 'Clinical' &&
                getDefaultMenu != 'Stats' && getDefaultMenu != 'ETMF'
              "
            >
              <router-link to="/viewgraph" class="nav-link" @click.prevent="close"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/Data_export_n.png"
                  alt="Data Export"
                />
                <span v-if="notcollapsed">View Graph</span>
              </router-link>
            </li> -->
            <li
              class="submenuitem"
              v-if="
                rollsprivilages.includes('Mainmenu Data Export') &&
                isGenericMenu
              "
            >
              <router-link to="/dataExport" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/Data_export_n.png"
                  alt="Data Export"
                />
                <span v-if="notcollapsed"
                  >{{ t("navigations.data export") }}
                </span>
              </router-link>
            </li>
            <li
              class="submenuitem"
              v-if="
                rollsprivilages.includes('Mainmenu Data Standards') &&
                isGenericMenu
              "
            >
              <router-link to="/dataStandard" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/data_standards.png"
                  alt="Data Export"
                />
                <span v-if="notcollapsed">{{ "Data Standards" }} </span>
              </router-link>
            </li>
            <li
              class="submenuitem"
              v-if="
                rollsprivilages.includes('Mainmenu DMS') &&
                isGenericMenu
              "
            >
              <a
                class="fullwidthquery"
                href="#"
                @click.prevent="expandfun('dmsitem', 4, 'mainmenu')"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/dms_n.png"
                  alt="Home Menu" />
                <span class="nav-label">{{ t("navigations.dms") }} </span
                ><span
                  class="fa fa-angle-left angle-down-right mt-1"
                  :class="{
                    'float-right': isActive,
                    'rotate-down': !mainmenu[4],
                  }"
                ></span
              ></a>
              <ul id="dmsitem" class="nav nav-second-level collapse">
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('DMS Menu Document Upload')"
                >
                  <router-link to="/dms" class="nav-link"
                    ><img
                      class="me-1"
                      src="../../assets/img/dms.png"
                      alt="General DMS"
                    />
                    <span class="mt-1" v-if="notcollapsed">{{
                      t("navigations.document upload")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('DMS Menu Document Summary')"
                >
                  <router-link to="/dmssummaryreport" class="nav-link">
                    <img
                      class="me-1"
                      src="../../assets/img/received_query(2).png"
                      alt="Received Query Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.document summary")
                    }}</span>
                  </router-link>
                </li>
                <!-- document approval menu starts -->
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('DMS Menu Document Approval')"
                >
                  <router-link to="/documentapprovallist" class="nav-link"
                    ><img
                      class="me-1"
                      src="../../assets/img/doc_approval.png"
                      alt="Document Approval"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.document approval")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('DMS Menu Documents')"
                >
                  <router-link to="/documentsummary" class="nav-link"
                    ><img
                      class="me-1"
                      src="../../assets/img/documentsummary.png"
                      alt="Document Summary"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.documents")
                    }}</span>
                  </router-link>
                </li>
              </ul>
            </li>

            <!-- IOT menu starts  -->

            <!-- <li v-if="rollsprivilages.includes('Mainmenu IOT')"> -->
            <li
              v-if="
                rollsprivilages.includes('Mainmenu IOT') &&
                isGenericMenu
              "
            >
              <a href="#" @click.prevent="expandfun('iotmenu', 2, 'mainmenu')"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/iot_n.svg"
                  alt="Home Menu" />
                <span class="nav-label">{{ t("navigations.iot") }} </span
                ><span
                  class="fa fa-angle-left angle-down-right mt-1"
                  :class="{
                    'float-right': isActive,
                    'rotate-down': !mainmenu[2],
                  }"
                ></span
              ></a>
              <ul id="iotmenu" class="nav nav-second-level collapse">
                <li
                  v-if="rollsprivilages.includes('IOT Google Fit')"
                  class="submenuitem"
                >
                  <router-link to="/googlefitscreen" class="nav-link"
                    ><img
                      class="me-2 mb-1"
                      src="../../assets/img/google_fit.svg"
                      alt="Google Fit Menu"
                    />
                    <span v-if="notcollapsed"
                      >{{ t("navigations.google fit") }}
                    </span>
                  </router-link>
                </li>
                <li
                  v-if="rollsprivilages.includes('IOT IOT Devices')"
                  class="submenuitem"
                >
                  <router-link to="/IOTDevices" class="nav-link"
                    ><img
                      class="me-2 mb-1"
                      src="../../assets/img/iot_devices.svg"
                      alt="Home Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.iot devices")
                    }}</span>
                  </router-link>
                </li>

                <li
                  v-if="rollsprivilages.includes('IOT IOT Patients')"
                  class="submenuitem"
                >
                  <router-link to="/IOTPatients" class="nav-link"
                    ><img
                      class="me-2 mb-1"
                      src="../../assets/img/iot_patients.svg"
                      alt="Home Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.iot subjects")
                    }}</span>
                  </router-link>
                </li>
              </ul>
            </li>

            <!-- IOT menu ends -->

            <!-- Administration menu starts  -->
            <li
              v-if="
                rollsprivilages.includes('Mainmenu Administration') &&
                isGenericMenu
              "
            >
              <a
                href="#"
                @click.prevent="expandfun('administrationmenu', 3, 'mainmenu')"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/administration.svg"
                  alt="Administration Menu" />
                <span class="nav-label"
                  >{{ t("navigations.administration") }} </span
                ><span
                  class="fa fa-angle-left angle-down-right mt-1"
                  :class="{
                    'float-right': isActive,
                    'rotate-down': !mainmenu[3],
                  }"
                ></span
              ></a>
              <ul id="administrationmenu" class="nav nav-second-level collapse">
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('Administration Users')"
                >
                  <router-link to="/userlisting" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/users.svg"
                      alt="Users Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.users")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('Administration Roles')"
                >
                  <router-link to="/roleList" class="nav-link">
                    <img
                      class="me-1 mb-1"
                      src="../../assets/img/roles.svg"
                      alt="Roles Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.roles")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="
                    rollsprivilages.includes('Administration Role Privileges')
                  "
                >
                  <router-link to="/RoleScreen" class="nav-link">
                    <img
                      class="me-1 mb-1"
                      src="../../assets/img/role_privilege.svg"
                      alt="Role Privilege Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.role privileges")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('Administration Screen')"
                >
                  <router-link to="/screen" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/screen_privilage.svg"
                      alt="Screens Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.screen")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="
                    rollsprivilages.includes('Administration Site Privilege')
                  "
                >
                  <router-link to="/siteprivilege" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/site_privilege.svg"
                      alt="Site Privilege Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.site privilege")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="
                    rollsprivilages.includes('Administration Field Privileges')
                  "
                >
                  <router-link to="/fieldprivileges" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/field_privilege.svg"
                      alt="Field Privileges Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.field privileges")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="
                    rollsprivilages.includes(
                      'Administration Device Controllers'
                    )
                  "
                >
                  <router-link to="/devicecontrollers" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/device_control.png"
                      alt="Device Controllers Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.device controllers")
                    }}</span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('Organization Settings')"
                >
                  <router-link to="/organization_settings" class="nav-link"
                    ><img
                      class="me-1 mb-1"
                      src="../../assets/img/organization_settings.svg"
                      alt="Organization Settings"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.organization_settings")
                    }}</span>
                  </router-link>
                </li>
              </ul>
            </li>

            <!-- Administration menu ends -->
            <!-- <li v-if="rollsprivilages.includes('Mainmenu Study Template')">
              <router-link to="/studytemplate" class="nav-link" @click.prevent="close"
                ><img
                  class="me-1"
                  src="../../assets/img/study_template.png"
                  alt="Study Template Menu"
                />
                <span v-if="notcollapsed">{{ t("navigations.study template") }} </span>
              </router-link>
            </li>
            <li v-if="rollsprivilages.includes('Mainmenu Data Entry')">
              <router-link to="/visitforms" class="nav-link" @click.prevent="close"
                ><img
                  class="me-1"
                  src="../../assets/img/data_entry.png"
                  alt="Data Entry Menu"
                />
                <span v-if="notcollapsed">{{ t("navigations.data entry") }}</span>
              </router-link>
            </li> -->

            <li
              class="fullwidthquery"
              v-if="
                rollsprivilages.includes('Mainmenu Form Library') &&
                isGenericMenu
              "
            >
              <a
                href="#"
                class="fullwidthquery"
                @click.prevent="expandfun('formlibrarysetup', 5, 'submenu')"
              >
                <img
                  class="me-1 mb-1"
                  src="../../assets/img/form_library.svg"
                  alt="Transfer"
                />
                <span
                  class="fa fa-angle-left angle-down-right mt-1"
                  :class="{
                    'float-right': isActive,
                    'rotate-down': submenu[5] == true,
                  }"
                ></span>
                <span class="nav-label"
                  >{{ t("navigations.form library") }}
                </span>
              </a>
              <ul id="formlibrarysetup" class="nav nav-second-level collapse">
                <!-- <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('Form Library Menu Designer Tool')"
                >
                  <router-link
                    to="/formdesignertool"
                    class="nav-link"
                    @click.prevent="close"
                  >
                    <img
                      class="me-1 mb-1"
                      src="../../assets/img/designer_tool.svg"
                      alt="Template Menu"
                    />
                    <span v-if="notcollapsed">{{ t("navigations.designer tool") }}</span>
                  </router-link>
                </li> -->

                <li
                  class="submenuitem"
                  v-if="rollsprivilages.includes('Form Library Menu Templates')"
                >
                  <router-link to="/templatelisting" class="nav-link">
                    <img
                      class="me-1 mb-1"
                      src="../../assets/img/templates.svg"
                      alt="Template Menu"
                    />
                    <span v-if="notcollapsed"
                      >{{ t("navigations.forms") }}
                    </span>
                  </router-link>
                </li>
                <li
                  class="submenuitem"
                  v-if="
                    rollsprivilages.includes(
                      'Form Library Menu Approve Template'
                    )
                  "
                >
                  <router-link to="/digitalform/templatelist" class="nav-link">
                    <img
                      class="me-1 mb-2"
                      src="../../assets/img/approve_template.svg"
                      alt="Template Menu"
                    />
                    <span v-if="notcollapsed">{{
                      t("navigations.approve forms")
                    }}</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li
              class="fullwidthquery"
              v-if="
                rollsprivilages.includes('Mainmenu smart') &&
                isGenericMenu
              "
            >
              <a
                href="#"
                class="fullwidthquery"
                @click.prevent="expandfun('smartmenu', 6, 'submenu')"
              >
                <img
                  class="me-1 mb-1"
                  src="../../assets/img/smart.svg"
                  alt="Smart 2.0"
                />
                <span class="nav-label">{{ t("navigations.smart") }} </span>
                <span
                  class="fa fa-angle-left angle-down-right mt-1"
                  :class="{
                    'float-right': isActive,
                    'rotate-down': submenu[6] == true,
                  }"
                ></span>
              </a>
              <ul id="smartmenu" class="nav nav-second-level collapse">
                <li class="submenuitem">
                  <router-link to="/sapConnection" class="nav-link">
                    <img
                      class="me-1 mb-1"
                      src="../../assets/img/sap.svg"
                      alt="SAP"
                    />
                    <span v-if="notcollapsed">{{ t("navigations.sap") }} </span>
                  </router-link>
                </li>
                <li class="submenuitem">
                  <router-link to="/crm" class="nav-link">
                    <img
                      class="me-1 mb-1"
                      src="../../assets/img/crm.svg"
                      alt="CRM"
                    />
                    <span v-if="notcollapsed">{{ t("navigations.crm") }}</span>
                  </router-link>
                </li>
                <li class="submenuitem">
                  <router-link to="/inventoryTracking" class="nav-link">
                    <img
                      class="me-1 mb-1"
                      src="../../assets/img/inventory_tracking.svg"
                      alt="Inventory Tracking"
                    />
                    <span v-if="notcollapsed"
                      >{{ t("navigations.inventoryTracking") }}
                    </span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li
              class="submenuitem"
              v-if="
                rollsprivilages.includes('Mainmenu Import to Form Library') &&
                isGenericMenu
              "
            >
              <router-link to="/importtoformlibrary" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/icons/ImportStudy.png"
                  alt="importtoformlibrary"
                />
                <span v-if="notcollapsed">{{
                  $t("navigations.importtoformlibrary")
                }}</span>
              </router-link>
            </li>
            <!-- <li
              class="submenuitem"
              v-if="
                rollsprivilages.includes('Import to Form Library')"
            >
              <router-link
                to="/importtoformlibrary"
                class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/upload_study_protocol.png"
                  alt="alerts"
                />
                <span v-if="notcollapsed">{{ $t("navigations.importtoformlibrary") }} </span>
              </router-link>
            </li> -->
            <li
              class="submenuitem"
              v-if="
                rollsprivilages.includes('Mainmenu Alerts') &&
                getDefaultMenu == 'alerts'
              "
            >
              <router-link to="/alerts" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/Data_export_n.png"
                  alt="alerts"
                />
                <span v-if="notcollapsed"
                  >{{ $t("navigations.alert dashboard") }}
                </span>
              </router-link>
            </li>
            <li
              class="submenuitem"
              v-if="
                rollsprivilages.includes('Mainmenu Alerts') &&
                getDefaultMenu == 'alerts'
              "
            >
              <router-link to="/AlertSummary" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/Data_export_n.png"
                  alt="alerts"
                />
                <span v-if="notcollapsed"
                  >{{ $t("navigations.alert summary") }}
                </span>
              </router-link>
            </li>
            <li
              class="submenuitem"
              v-if="
                rollsprivilages.includes('Mainmenu setalert') &&
                getDefaultMenu == 'alerts'
              "
            >
              <router-link to="/setalert" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/Data_export_n.png"
                  alt="setalert"
                />
                <span v-if="notcollapsed"
                  >{{ $t("navigations.ecrf alert configuration") }}
                </span>
              </router-link>
            </li>
            <li
              class="submenuitem"
              v-if="
                rollsprivilages.includes('Mainmenu setfhiralert') &&
                getDefaultMenu == 'alerts'
              "
            >
              <router-link to="/setfhiralert" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/Data_export_n.png"
                  alt="setalert"
                />
                <span v-if="notcollapsed"
                  >{{ $t("navigations.fhir alert configuration") }}
                </span>
              </router-link>
            </li>
            <li
              class="submenuitem"
              v-if="
                rollsprivilages.includes('Mainmenu Alerts') &&
                getDefaultMenu == 'alerts'
              "
            >
              <router-link to="/alertreport" class="nav-link"
                ><img
                  class="me-1 mb-1"
                  src="../../assets/img/Data_export_n.png"
                  alt="alertreport"
                />
                <span v-if="notcollapsed"
                  >{{ $t("navigations.alert report") }}
                </span>
              </router-link>
            </li>
            <li
              class="fullwidthquery"
              @mouseleave="mouseItemLeave('querysetup')"
              v-if="getDefaultMenu == 'alerts'"
            >
              <a
                href="#"
                class="fullwidthquery"
                @click.prevent="expandfun('querysetup', 1, 'submenu')"
                ><img
                  class="me-1 mb-0"
                  src="../../assets/img/queries_n.png"
                  alt="QueryMenu" />
                <span class="nav-label">{{ t("navigations.queries") }} </span
                ><span
                  class="fa fa-angle-left angle-down-right mt-1"
                  :class="{
                    'float-right': isActive,
                    'rotate-down': submenu[1] == true,
                  }"
                ></span
              ></a>
              <ul
                id="querysetup"
                class="nav nav-second-level collapse"
                v-if="isActive"
              >
                <li
                  v-if="rollsprivilages.includes('Query Menu Sent')"
                  class="submenuitem"
                >
                  <router-link to="/sentQueryListForAlert" class="nav-link">
                    <!-- <img class="me-1 thirdlevel" src="../../assets/img/sent_queries_n.png" alt="Sent Query Menu"/> -->
                    <span class="me-1 mb-1 thirdlevel" v-if="notcollapsed">{{
                      t("navigations.sent")
                    }}</span>
                  </router-link>
                </li>
                <li
                  v-if="rollsprivilages.includes('Query Menu Received')"
                  class="submenuitem"
                >
                  <router-link to="/ReceivedqueryForAlerts" class="nav-link">
                    <!-- <img class="me-1 thirdlevel" src="../../assets/img/received_query_dark_n.png" alt="Received Query Menu" /> -->
                    <span class="me-1 mb-1 thirdlevel" v-if="notcollapsed">{{
                      t("navigations.received")
                    }}</span>
                  </router-link>
                </li>
                <li
                  v-if="rollsprivilages.includes('Query Menu All Queries')"
                  class="submenuitem"
                >
                  <router-link to="/allQueriesForAlert" class="nav-link">
                    <!-- <img class="me-1 thirdlevel" src="../../assets/img/total_queries_n.png" alt="All Query Menu"/> -->
                    <span class="me-1 mb-1 thirdlevel" v-if="notcollapsed">{{
                      t("navigations.all queries")
                    }}</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <!-- <li v-if="rollsprivilages.includes('Mainmenu Settings')">
              <router-link
                to="/settings"
                class="nav-link"
                @click.prevent="close"
              >
                <img class="me-1" src="../../assets/img/settings.png" alt="Settings Menu">
                <span v-if="notcollapsed">{{ t('navigations.settings') }}</span>
              </router-link>
            </li> -->

            <!-- <li v-if="rollsprivilages.includes('Mainmenu Report')">
              <router-link
                to="/report"
                class="nav-link"
                @click.prevent="close"
              >
                <i class="fa fa-gear"></i>
                <span v-if="notcollapsed">report</span>
              </router-link>
            </li> -->
            <ul
              id="itemsetup"
              class="nav nav-third-level collapse"
              v-if="isActive == false"
            >
              <li
                class="submenuitem"
                v-if="
                  rollsprivilages.includes('Study Components Menu Form Summary')
                "
              >
                <router-link to="/formSummary" class="nav-link"
                  ><img
                    class="me-1 thirdlevel"
                    src="../../assets/img/form_summary.png"
                    alt="Form Summary Menu"
                  />
                  <span v-if="notcollapsed">{{
                    t("navigations.form summary")
                  }}</span>
                </router-link>
              </li>
              <li
                class="submenuitem"
                v-if="rollsprivilages.includes('Study Components Menu Sites')"
              >
                <router-link to="/sitelist" class="nav-link"
                  ><img
                    class="me-1 thirdlevel"
                    src="../../assets/img/sites_n.png"
                    alt="Sites Menu"
                  />
                  <span v-if="notcollapsed">{{ t("navigations.sites") }} </span>
                </router-link>
              </li>

              <li
                class="submenuitem"
                v-if="
                  rollsprivilages.includes('Study Components Menu Subjects')
                "
              >
                <router-link to="/patientlist" class="nav-link"
                  ><img
                    class="me-1 thirdlevel"
                    src="../../assets/img/subject.png"
                    alt="Subjects Menu"
                  />
                  <span v-if="notcollapsed"
                    >{{ t("navigations.subjects") }}
                  </span>
                </router-link>
              </li>
              <li
                class="submenuitem"
                v-if="
                  rollsprivilages.includes('Study Components Menu Subjects')
                "
              >
                <router-link to="/eConsentList" class="nav-link"
                  ><img
                    class="me-1 thirdlevel"
                    src="../../assets/img/subject.png"
                    alt="Subjects Menu"
                  />
                  <span v-if="notcollapsed"
                    >{{ t("navigations.e-consent") }}
                  </span>
                </router-link>
              </li>
              <li
                class="submenuitem"
                v-if="rollsprivilages.includes('Study Components Menu Visits')"
              >
                <router-link to="/visitlist" class="nav-link">
                  <img
                    class="me-1 thirdlevel"
                    src="../../assets/img/visits.png"
                    alt="Visits Menu"
                  />
                  <span v-if="notcollapsed">{{ t("navigations.visits") }}</span>
                </router-link>
              </li>
              <li
                class="submenuitem"
                v-if="
                  rollsprivilages.includes(
                    'Study Components Menu Visit Templates'
                  )
                "
              >
                <router-link to="/formTemplates" class="nav-link"
                  ><img
                    class="me-1 thirdlevel"
                    src="../../assets/img/study_template.png"
                    alt="Subjects Menu"
                  />
                  <span v-if="notcollapsed"
                    >{{ t("navigations.visit forms") }}
                  </span>
                </router-link>
              </li>
              <li
                class="submenuitem"
                v-if="
                  rollsprivilages.includes(
                    'Study Components Menu Submitted Forms'
                  )
                "
              >
                <router-link to="/listform" class="nav-link"
                  ><img
                    class="me-1 thirdlevel"
                    src="../../assets/img/forms.png"
                    alt="Form Menu"
                  />
                  <span v-if="notcollapsed">{{
                    t("navigations.submitted forms")
                  }}</span>
                </router-link>
              </li>
              <li
                class="submenuitem"
                v-if="
                  rollsprivilages.includes(
                    'Study Components Menu Unassigned Form'
                  )
                "
              >
                <router-link to="/displayform" class="nav-link"
                  ><img
                    class="me-1 thirdlevel"
                    src="../../assets/img/assign-form.png"
                    alt="Assign Form Menu"
                  />
                  <span v-if="notcollapsed">{{
                    t("navigations.unassigned forms")
                  }}</span>
                </router-link>
              </li>
              <li
                class="submenuitem"
                v-if="
                  rollsprivilages.includes(
                    'Study Components Menu Partially Filled Forms'
                  )
                "
              >
                <router-link to="/reviewFormList" class="nav-link"
                  ><img
                    class="me-1 thirdlevel"
                    src="../../assets/img/assign_form.png"
                    alt="Form Menu"
                  />
                  <span v-if="notcollapsed">{{
                    t("navigations.partially filled forms")
                  }}</span>
                </router-link>
              </li>
              <li
                class="submenuitem"
                v-if="
                  !rollsprivilages ||
                  rollsprivilages.includes('Study Components Menu Users')
                "
              >
                <router-link to="/StudyBasedUserList" class="nav-link"
                  ><img
                    class="me-1 thirdlevel"
                    src="../../assets/img/users.png"
                    alt="Users Menu"
                  />
                  <span v-if="notcollapsed">{{ t("navigations.users") }}</span>
                </router-link>
              </li>
              <li
                class="submenuitem"
                v-if="
                  rollsprivilages.includes(
                    'Study Components Menu Archived Forms'
                  )
                "
              >
                <router-link to="/Archive" class="nav-link"
                  ><img
                    class="me-1 thirdlevel"
                    src="../../assets/img/archive.png"
                    alt="Form Menu"
                  />
                  <span v-if="notcollapsed">{{
                    t("navigations.archived forms")
                  }}</span>
                </router-link>
              </li>
            </ul>
            <ul
              id="querysetup"
              class="nav nav-third-level collapse"
              v-if="isActive == false"
            >
              <!-- <li class="submenuitem">
                  <router-link to="/generalQuery" class="nav-link">
                    <i class="fa fa-question thirdlevel"></i>
                    <span v-if="notcollapsed">Raise Query</span>
                  </router-link>
                </li> -->
              <li
                v-if="rollsprivilages.includes('Query Menu Sent')"
                class="submenuitem"
              >
                <router-link to="/sentQueryList" class="nav-link">
                  <img
                    class="me-1 thirdlevel"
                    src="../../assets/img/sent_queries_n.png"
                    alt="Sent Query Menu"
                  />
                  <span v-if="notcollapsed">{{ t("navigations.sent") }}</span>
                </router-link>
              </li>
              <li
                v-if="rollsprivilages.includes('Query Menu Received')"
                class="submenuitem"
              >
                <router-link to="/queryList" class="nav-link">
                  <img
                    class="me-1 thirdlevel"
                    src="../../assets/img/received_query_dark_n.png"
                    alt="Received Query Menu"
                  />
                  <span v-if="notcollapsed">{{
                    t("navigations.received")
                  }}</span>
                </router-link>
              </li>
              <li
                v-if="rollsprivilages.includes('Query Menu All Queries')"
                class="submenuitem"
              >
                <router-link to="/allQueryList" class="nav-link">
                  <img
                    class="me-1 thirdlevel"
                    src="../../assets/img/all_queries.png"
                    alt="All Query Menu"
                  />
                  <span v-if="notcollapsed">{{
                    t("navigations.all queries")
                  }}</span>
                </router-link>
              </li>
              <li
                v-if="rollsprivilages.includes('Query Menu General')"
                class="submenuitem"
              >
                <router-link to="/general_querylist" class="nav-link">
                  <img
                    class="me-1 thirdlevel"
                    src="../../assets/img/general_querylist.png"
                    alt="General Query Menu"
                  />
                  <span v-if="notcollapsed">{{
                    t("navigations.general")
                  }}</span>
                </router-link>
              </li>
            </ul>
            <ul
              id="formdesignersetup"
              class="nav nav-third-level collapse"
              v-if="isActive == false"
            >
              <li
                class="submenuitem"
                v-if="
                  rollsprivilages.includes('Form Designer Menu Designer Tool')
                "
              >
                <router-link to="/formdesigner" class="nav-link">
                  <img
                    class="me-1 thirdlevel"
                    src="../../assets/img/template.png"
                    alt="Template Menu"
                  />
                  <span v-if="notcollapsed">{{
                    t("navigations.designer tool")
                  }}</span>
                </router-link>
              </li>
              <li class="submenuitem">
                <router-link to="/mlCriteriaCapture" class="nav-link">
                  <img
                    class="me-1 thirdlevel"
                    src="../../assets/img/template.png"
                    alt="Template Menu"
                  />
                  <span v-if="notcollapsed">{{
                    t("navigations.ai tool")
                  }}</span>
                </router-link>
              </li>

              <li
                class="submenuitem"
                v-if="rollsprivilages.includes('Form Designer Menu Templates')"
              >
                <router-link to="/templatelist" class="nav-link">
                  <img
                    class="me-1 thirdlevel"
                    src="../../assets/img/template.png"
                    alt="Template Menu"
                  />
                  <span v-if="notcollapsed"
                    >{{ t("navigations.templates") }}
                  </span>
                </router-link>
              </li>

              <li
                class="submenuitem"
                v-if="
                  rollsprivilages.includes(
                    'Form Designer Menu Approve Template'
                  )
                "
              >
                <router-link to="/digitalform/templatelist" class="nav-link">
                  <img
                    class="me-1 thirdlevel"
                    src="../../assets/img/template.png"
                    alt="Template Menu"
                  />
                  <span v-if="notcollapsed">{{
                    t("navigations.approve forms")
                  }}</span>
                </router-link>
              </li>
            </ul>
            <ul
              id="studyadministrationsetup"
              class="nav nav-third-level collapse"
              v-if="isActive == false"
            >
              <li
                class="submenuitem"
                v-if="
                  rollsprivilages.includes(
                    'Study Administration Menu Form Transfer'
                  )
                "
              >
                <router-link to="/formtransfer" class="nav-link"
                  ><img
                    class="me-1 thirdlevel"
                    src="../../assets/img/formtransfer.png"
                    alt="Transfer"
                  />
                  <span v-if="notcollapsed">Form Transfer</span>
                </router-link>
              </li>
              <li
                class="submenuitem"
                v-if="
                  rollsprivilages.includes(
                    'Study Administration Menu Subject Transfer'
                  )
                "
              >
                <router-link to="/TransferSubject" class="nav-link"
                  ><img
                    class="me-1 thirdlevel"
                    src="../../assets/img/patient_transfer.png"
                    alt="Transfer"
                  />
                  <span v-if="notcollapsed">Subject Transfer </span>
                </router-link>
              </li>
              <li
                class="submenuitem"
                v-if="
                  rollsprivilages.includes(
                    'Study Administration Menu Subject Schedule'
                  )
                "
              >
                <router-link to="/PatientScheduleView" class="nav-link"
                  ><img
                    class="me-1 thirdlevel"
                    src="../../assets/img/subject_schedule.png"
                    alt="Subject Schedule Menu"
                  />
                  <span v-if="notcollapsed">{{
                    t("navigations.subject schedule")
                  }}</span>
                </router-link>
              </li>
              <li
                class="submenuitem"
                v-if="
                  rollsprivilages.includes(
                    'Study Administration Menu Patient Login'
                  )
                "
              >
                <router-link to="/patientLoginList" class="nav-link"
                  ><img
                    class="me-1 thirdlevel"
                    src="../../assets/img/Patient_login.png"
                    alt="Subjects Login Menu"
                  />
                  <span v-if="notcollapsed"
                    >{{ t("navigations.patient login") }}
                  </span>
                </router-link>
              </li>
              <li
                class="submenuitem"
                v-if="
                  !rollsprivilages ||
                  rollsprivilages.includes(
                    'Study Administration Menu Unscheduled Visits'
                  )
                "
              >
                <router-link to="/unscheduledvisits" class="nav-link"
                  ><img
                    class="me-1 thirdlevel"
                    src="../../assets/img/unscheduled_visits.png"
                    alt="Unscheduled Visits Menu"
                  />
                  <span v-if="notcollapsed">{{
                    t("navigations.unscheduled visits")
                  }}</span>
                </router-link>
              </li>
              <li
                class="submenuitem"
                v-if="
                  rollsprivilages.includes(
                    'Study Administration Menu Change Schedule Template'
                  )
                "
              >
                <router-link to="/visittemplate" class="nav-link"
                  ><img
                    class="me-1 thirdlevel"
                    src="../../assets/img/visits_templates.png"
                    alt="Visit Templates Menu"
                  />
                  <span v-if="notcollapsed">{{
                    t("navigations.change schedule template")
                  }}</span>
                </router-link>
              </li>
            </ul>
          </ul>
        </div>
      </nav>
      <div
        :id="!isLoginPage ? 'page-wrapper' : null"
        class="gray-bg"
        :class="{ 'page-wrapper--full-width': !showSideNavbar }"
      >
        <router-view />
      </div>
    </div>
  </div>
  <createStudyPopup
    v-if="createstudypopup"
    @studyCreated="loadstudy"
    @closeModal="createstudypopup = false"
  />
  <CreateVideoCallSchedulePopUp
    v-if="CreateVideoCallSchedulePopUp"
    @closeModal="CreateVideoCallSchedulePopUp = false"
  />
  <DefaultSetupPopUp
    v-if="DefaultSetupPopUp"
    @closeModal="DefaultSetupPopUp = false"
  />

  <!-- <ViewReportPopUp
  v-if="ViewReportPopUp"
  @closeModal="ViewReportPopUp = false"
  /> -->
  <!-- <uploadFile
    v-if="showupload"
    @closeModal="showupload = false"
  /> -->
  <!-- Import study modal -->
  <ImportStudyModal
    :visible="showImportStudy"
    :show-loading="showLoading"
    :has-file-validation-error="validations[0] == false"
    :import-type="importPopupType"
    @close="closeModal"
    @download-template="downloadImportTemplate"
    @file-change="previewFiles"
    @import-study="importStudy"
  />
  <!-- End of import study modal -->
</template>

<script>
/* eslint-disable */
import config from "../../../auth_config";
import createAuth0Client from "@auth0/auth0-spa-js";
import {
  defineComponent,
  watch,
  ref,
  watchEffect,
  computed,
  nextTick,
  onMounted,
  onUnmounted,
} from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import axios from "axios";
import moment from "moment";
import jwt_decode from "jwt-decode";
import { useI18n } from "vue-i18n";
import { performLogout } from "@/Shared/logout";
import createStudyPopup from "../../components/createStudyPopup/createStudyPopup.vue";
import uploadFile from "../../components/UploadFile/UploadFile.vue";
import CreateVideoCallSchedulePopUp from "../../components/CreateVideoCallSchedulePopUp/CreateVideoCallSchedulePopUp.vue";
import DefaultSetupPopUp from "../../components/DefaultSetupPopUp/DefaultSetupPopUp.vue";
import ImportStudyModal from "./ImportStudyModal.vue";
//import ViewReportPopUp from "../../components/ViewReportPopUp/ViewReportPopUp.vue";
export default {
  name: "Navbar",
  components: {
    createStudyPopup,
    CreateVideoCallSchedulePopUp,
    DefaultSetupPopUp,
    uploadFile,
    ImportStudyModal,
    //ViewReportPopUp
  },
  setup() {
    const store = useStore();
    const { d, t, locale } = useI18n({ useScope: "global" });
    let auth0Client = ref();
    let currentTheme = ref(localStorage.getItem("theme-color"));
    let valnow = ref("");
    let querylist = ref([]);
    let isActive = ref(true);
    let isRightActive = ref(false);
    let studydetails = ref([]);
    let studyDetails = ref([]);
    let versiondetailsobj = ref([]);
    let isArmSpecific = ref(false);
    let querycount = ref();
    let studies = ref([]);
    let arr = ref([]);
    let mainmenu = ref([true, true, true, true, true, true, true, true, true]);
    let submenu = ref([false, false, false, false]);
    let collapseSideBar = ref(false);
    let showArrows = ref(false);
    let createstudypopup = ref(false);
    let CreateVideoCallSchedulePopUp = ref(false);
    let DefaultSetupPopUp = ref(false);
    let currentRoleName = ref("");
    let mobileNavOpen = ref(false);
    let mobileThemeOpen = ref(false);
    //let ViewReportPopUp = ref(false);

    const router = useRouter();
    const route = useRoute();
    let baseurl = ref(`${process.env.VUE_APP_Service_URL}`);
    let baseapi = ref(`${process.env.VUE_APP_Service_URL}/management/study/`);
    let showImportStudy = ref(false);
    let importPopupType = ref("study");
    let showupload = ref(false);
    let studyFile = ref("");
    let showLoading = ref(false);
    let validations = ref([true]);
    const onStudyListChanged = () => {
      refreshNavbarData();
    };

    const onDocumentClick = (event) => {
      const notificationicon = document.querySelector(".notification-block");
      const thememenu = document.querySelector(".theme-menu");
      const profile = document.querySelector(".profile-block");
      const target = event.target instanceof Element ? event.target : null;
      const ignoredClickTarget = target && target.closest(
        ".count-info, .query-icon, .setings-item, .md-skin, .theme-change-block, .user-block, .profile-pic, .profile-block, .user-details"
      );
      if (
        ignoredClickTarget
      ) {
        return;
      }
      if (profile) profile.style.display = "none";
      if (notificationicon) notificationicon.style.display = "none";
      if (thememenu) thememenu.style.display = "none";
      mobileNavOpen.value = false;
      mobileThemeOpen.value = false;
    };

    const mediaMin = window.matchMedia("(min-width:769px)");
    const mediaMax = window.matchMedia("(max-width:769px)");
    const onMinWidthChange = () => initNav();
    const onMaxWidthChange = () => initArrow();

    let removeRouterGuard = null;
    let isRefreshingNavbarData = false;
    let shouldRefreshNavbarDataAgain = false;

    const addMediaListener = (mediaQuery, handler) => {
      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener("change", handler);
      } else {
        mediaQuery.addListener(handler);
      }
    };

    const removeMediaListener = (mediaQuery, handler) => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener("change", handler);
      } else {
        mediaQuery.removeListener(handler);
      }
    };

    async function refreshNavbarData() {
      if (isRefreshingNavbarData) {
        shouldRefreshNavbarDataAgain = true;
        return;
      }

      isRefreshingNavbarData = true;
      try {
        shouldRefreshNavbarDataAgain = false;
        await loadstudy();
        await Promise.all([
          getStudyDetails(),
          getquerydetails(),
          getCurrentRoleName(),
        ]);
      } finally {
        isRefreshingNavbarData = false;
        if (shouldRefreshNavbarDataAgain) {
          await refreshNavbarData();
        }
      }
    }

    onMounted(async () => {
      window.addEventListener("StudyListChanged", onStudyListChanged);
      document.addEventListener("click", onDocumentClick);
      addMediaListener(mediaMin, onMinWidthChange);
      addMediaListener(mediaMax, onMaxWidthChange);
      if (currentTheme.value == null) {
        localStorage.setItem("theme-color", "theme-default");
        currentTheme.value = localStorage.getItem("theme-color");
      }
      auth0Client.value = await createAuth0Client({
        domain: config.domain,
        client_id: config.clientId,
      });
      anchorlink();
    });
    // Handle cleanup when navigating away from the route
    removeRouterGuard = router.beforeEach((to, from, next) => {
      if (to.name == "landingPage") {
        store.dispatch("setDefaultMenu", "");
      }
      next();
    });
    function gotointelligentdashboard(){
      router.push(`/InteligentDashboard`);
    }
    async function returnToLanding() {
      await router.push("/landingPage");
      await nextTick();
      mainmenu.value = [true, true, true, true, true, true, true, true, true];
    }
    async function openUploadFile() {
      showupload.value = true;
    }
    async function importStudypopup(type = "study") {
      importPopupType.value = type;
      showImportStudy.value = true;
    }
    async function closeModal() {
      loadstudy();
      showImportStudy.value = false;
      if (studyFile) {
        studyFile.value = "";
      }
    }
    async function previewFiles(event) {
      studyFile.value = event.target.files[0];
    }
      async function changeStudyList() {
      const idtoken = store.getters.getIdToken;
      if (!idtoken) {
        return;
      }
      const usermail = jwt_decode(idtoken).email;
      await axios.get(`${baseapi.value}getallstudy?user=${usermail}`, {
        headers: {
          Authorization: `Bearer ${idtoken}`,
          "Content-Type": "application/json",
        }
      })
        .then((res) => {
          window.dispatchEvent(
            new CustomEvent("StudyListChanged", {

            })
          );
        })
    }
    async function importStudy() {
      await validateNull();
      if (validations.value[0]) {
        showLoading.value = true;
        const idtoken = store.getters.getIdToken;

        const formData = new FormData();
        formData.append("file", studyFile.value);
        let errormsg = "";
        const isSoAImport =
          (importPopupType.value || "").toLowerCase() === "soa";
        const importApi = isSoAImport
          ? `${baseurl.value}/management/studyimport/upload`
          : `${baseapi.value}import`;
        await axios
          .post(importApi, formData, {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "multipart/form-data",
            },
            ...(isSoAImport ? {} : { responseType: "blob" }),
          })
          .then((res) => {
            console.log("Import file...", res);

            if (!isSoAImport) {
              const disposition = res.headers["content-disposition"];
              let fileName = "study_results.xlsx";

              if (disposition && disposition.indexOf("filename=") !== -1) {
                const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(
                  disposition
                );
                if (matches != null && matches[1]) {
                  fileName = matches[1].replace(/['"]/g, "");
                }
              }

              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }

            showLoading.value = false;
            alert(isSoAImport ? "SoA imported successfully" : "Study imported successfully");
            if (res.headers && res.headers["studyid"]) {
              studychange(res.headers["studyid"]);
            }
            closeModal();
            router.push(`/studyProfile`);
            
          })
          .catch((err) => {
            showLoading.value = false;
            studyFile.value = "";

            if (err.response && err.response.data instanceof Blob) {
              err.response.data
                .text()
                .then((blobText) => {
                  let errorData = {};
                  try {
                    errorData = JSON.parse(blobText);
                  } catch (parseError) {
                    alert("Something went wrong");
                    return;
                  }
                  console.log("Error while importing study:", errorData);

                  // Check for DomainValidations and handle specific errors
                  if (errorData.errors && errorData.errors.DomainValidations) {
                    const validationErrors = errorData.errors.DomainValidations;

                    // Handle specific error messages
                    if (
                      validationErrors.includes("Import Failed Invalid Study")
                    ) {
                      alert("Import Failed - Invalid Study Id/Study Name");
                    } else if (validationErrors.includes("Invalid File Type")) {
                      alert(
                        "Import Failed - Invalid File Type. Please upload a valid file."
                      );
                    } else {
                      alert("Something went wrong");
                    }
                  } else {
                    alert("Something went wrong");
                  }
                })
                .catch((blobError) => {
                  alert("Something went wrong");
                });
            } else {
              alert("Something went wrong");
            }
          });
      }
    }

    function blobToObject(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          try {
            const result = JSON.parse(reader.result); // Assuming it's a JSON blob
            resolve(result);
          } catch (err) {
            reject(err); // Handle JSON parsing errors
          }
        };
        reader.onerror = (err) => reject(err);
        reader.readAsText(blob); // Read the blob as text
      });
    }
    async function downloadImportTemplate() {
      const idtoken = store.getters.getIdToken;

      try {
        const res = await axios.get(`${baseapi.value}downloadimporttemplate`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "multipart/form-data",
          },
          responseType: "blob",
        });

        const contentDisposition =
          res.headers["content-disposition"] ||
          res.headers["Content-Disposition"];
        let fileName = "import_template.xlsx";

        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(
            /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          );
          const utf8FileNameMatch = contentDisposition.match(
            /filename\*=\s*UTF-8''(.+)/
          );

          if (fileNameMatch && fileNameMatch[1]) {
            fileName = fileNameMatch[1].replace(/['"]/g, "");
          } else if (utf8FileNameMatch && utf8FileNameMatch[1]) {
            fileName = utf8FileNameMatch[1];
          }
        } else {
          console.warn(
            "Content-Disposition header not found. Using default file name."
          );
        }

        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        alert("Import template downloaded successfully");
      } catch (err) {
        console.error("Error while downloading import template...", err);
        alert(
          "Something went wrong during the download. Please check console for details."
        );
      } finally {
        showLoading.value = false;
      }
    }

    async function validateNull() {
      if (
        studyFile.value != "" &&
        studyFile.value !== null &&
        studyFile.value !== undefined
      ) {
        validations.value[0] = true;
      } else {
        validations.value[0] = false;
      }
    }
    async function anchorlink() {
      let listItems = document.getElementsByClassName("nav-link");
      for (let i = 0; i <= listItems.length - 1; i++) {
        //console.log("The value are",listItems[i].innerText)
      }
    }
    watch(
      () => store.getters.getStudyIs,
      (studyId) => {
        valnow.value = studyId || "";
      },
      { immediate: true }
    );
    watch(
      () => store.getters.getIdToken,
      (idtoken) => {
        if (idtoken) {
          refreshNavbarData();
          return;
        }

        studies.value = [];
        valnow.value = "";
      },
      { immediate: true }
    );
    watch(
      () => store.getters.getRolesData,
      () => {
        getCurrentRoleName();
      },
      { deep: true }
    );

    let usersdetails = computed(function () {
      const idtoken = store.getters.getIdToken;
      if (!idtoken) {
        return {};
      }

      try {
        return jwt_decode(idtoken);
      } catch (err) {
        return {};
      }
    });
    async function getCurrentRoleName() {
      const idtoken = store.getters.getIdToken;
      if (!idtoken) {
        currentRoleName.value = "";
        return;
      }

      try {
        const usermail = jwt_decode(idtoken).email;
        const res = await axios.get(
          `${baseurl.value}/account-core/user/getuserroles`,
          {
            params: {
              userMail: usermail,
            },
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        const roles = Array.isArray(res.data) ? res.data : [];
        const storedRoles = store.getters.getRolesData;
        const currentRoleId = Array.isArray(storedRoles)
          ? storedRoles[0]
          : typeof storedRoles === "string"
            ? storedRoles.split(",")[0].trim()
            : storedRoles;
        const currentRole = roles.find(
          (role) => role.roleID === currentRoleId
        );
        currentRoleName.value = currentRole ? currentRole.roleName : "";
      } catch (err) {
        currentRoleName.value = "";
        console.log("Error loading current role", err);
      }
    }
    async function languagechange(val) {
      store.dispatch("setLanguage", val);
      //  router.push(`${router.currentRoute.value.path}`);
      router.push({
        name: router.currentRoute.value.name,
        params: { locale: val },
      });
    }
    let authenticated = computed(function () {
      return store.getters.authenticated;
    });
    let rollsprivilages = computed(function () {
      return store.getters.getRolesprivilegeData;
    });
    let defaultdashbord = computed(function () {
      return store.getters.getdefaultdashboard;
    });
    watch(
      [rollsprivilages, defaultdashbord, () => route.path],
      ([rprivileges, dashbrd, currentPath]) => {
        if (rprivileges && rprivileges != "test test," && dashbrd && currentPath == "/noprivilege") {
          router.push(`/${dashbrd}`);
        }
      },
      { immediate: true }
    );
    let isArmSpecificcompueted = computed(function () {
      return isArmSpecific.value;
    });
    let getNavbarstatus = computed(function () {
      return store.getters.getNavbarstatus;
    });
    let getDefaultMenu = computed(function () {
      return store.getters.getDefaultMenu;
    });
    const nonGenericMenus = [
      "Analytical",
      "AI/Ml",
      "CTMS",
      "EPRO",
      "Clinical",
      "Stats",
      "ETMF",
      "alerts",
    ];
    let isGenericMenu = computed(function () {
      return !nonGenericMenus.includes(getDefaultMenu.value);
    });
    var navbarStatus = getNavbarstatus.value;
    let root = document.querySelector(":root");
    let notcollapsed = true;
    let expandclass = "nav nav-second-level collapse";
    let user = computed(function () {
      return store.state.user;
    });
    let isLoginPage = computed(() => {
      return router.currentRoute.value.name === "login"  || router.currentRoute.value.name === "subjectlogin"; // or use: route.path === '/login'
    });
    const currentPage = computed(() => {
      const { name } = router.currentRoute.value;
      return [
        "landingPage",
        "fhirViewer",
        "crm",
        "inventoryTracking",
        "sapConnection",
        "rbqmdashboard",
        "f4pViewer",
      ].includes(name);
    });
    const hideSideNavbar = computed(() => {
      return (router.currentRoute.value.name === "subjectprofile" ||
      router.currentRoute.value.name === "eConsentDashboard");
    });
    const showSideNavbar = computed(() => {
      return (
        authenticated.value &&
        getNavbarstatus.value &&
        !currentPage.value &&
        !hideSideNavbar.value &&
        rollsprivilages.value != undefined
      );
    });
    let showselectstudy = computed(() => {
      return router.currentRoute.value.name === "rbqmdashboard"; // or use: route.path === '/login'
    });
    async function setdefaultstudy() {
      if (
        valnow.value == "" ||
        valnow.value == null ||
        valnow.value == "undefined"
      ) {
        const idtoken = store.getters.getIdToken;
        const userId = await jwt_decode(idtoken).sub;
        await axios
          .get(baseapi.value + "getdefaultstudy?id=" + userId, {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            if (res.statusText == "No Content") {
            } else {
              valnow.value = res.data.studyID;
              store.dispatch("setStudyID", res.data.studyID);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }

    async function logout() {
      await performLogout();
    }
    function switchTheme(theme) {
      localStorage.setItem("theme-color", theme);
      currentTheme.value = localStorage.getItem("theme-color");
    }
    async function getquerydetails() {
      const baseapi = process.env.VUE_APP_Service_URL;
      const currentstudyid = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      if (!currentstudyid || !idtoken) {
        querylist.value = [];
        querycount.value = 0;
        return;
      }
      // let querycountstd = 0;
      await axios
        .get(
          `${baseapi}/forms/query/getlatestqueries?StudyId=${currentstudyid}&GetRecivedOnly=true&Countof=6`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          querylist.value = res.data.data;
          querycount.value = res.data.count;
        })
        .catch((err) => {
          console.log(err);
        });
    }
    function gotoUrl(url) {
      if (url == "profileSettings") {
        router.push(`/profileSettings`);
        const profile = document.querySelector(".profile-block");
        if (profile) profile.style.display = "none";
      } else if (url == "generalQuery") {
        router.push(`/generalQuery`);
      } else if (url == "queryList") {
        router.push(`/queryList`);
      }
    }
    function displayNotification() {
      const notif = document.querySelector(".notification-block");
      if (!notif) return;
      if (notif.style.display == "block") {
        notif.style.display = "none";
      } else notif.style.display = "block";
    }
    function displayProfile() {
      getCurrentRoleName();
      const profile = document.querySelector(".profile-block");
      if (!profile) return;
      if (profile.style.display == "block") {
        profile.style.display = "none";
      } else profile.style.display = "block";
    }
    function filterDate(date) {
      if (date) {
        return moment(date).format("DD-MM-YYYY");
      }
    }
    function filterTime(time) {
      let defaultTime = localStorage.getItem("timeformat");
      if (time) {
        return moment(time).format(defaultTime);
      }
    }
    function filterNow(date) {
      if (date) {
        return moment(date).fromNow();
      }
    }
    async function viewreceived() {
      router.push(`/queryList`);
    }
    async function viewquery(id) {
      router.push(`/query/queryList/${id}`);
    }
    async function expandSidebar() {
      let x = document.getElementsByClassName("theme-menu")[0];
      if (!x) return;
      if (x.style.display == "block") {
        x.style.display = "none";
      } else x.style.display = "block";
    }
    function initArrow() {
      if (document.body.classList.contains("mini-navbar")) {
        document.body.classList.remove("mini-navbar");
      }
    }
    //mobile navbar initialised
    function initNav() {
      isActive.value = true;
      isRightActive.value = false;
      if (window.innerWidth > 769) {
        const mobileMenu = document.getElementById("mobilemenu");
        if (document.body.classList.contains("mini-navbar")) {
          document.body.classList.remove("mini-navbar");
          if (mobileMenu) mobileMenu.classList.toggle("navbar-static-side");
        } else if (mobileMenu) {
          mobileMenu.classList.add("navbar-default", "navbar-static-side");
        }
      }
    }
    //mobile and tab navbar close button
    async function loadstudy() {
      const idtoken = store.getters.getIdToken;
      if (!idtoken) {
        return;
      }

      let usermail = "";
      try {
        usermail = jwt_decode(idtoken).email;
      } catch (err) {
        return;
      }

      await axios
        .get(`${baseurl.value}/management/study/getallstudy?user=${usermail}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          const studyList = Array.isArray(res.data)
            ? res.data
            : Array.isArray(res.data && res.data.data)
              ? res.data.data
              : [];
          studies.value = studyList; //orderBy(studyList, 'studyName');
          let defaultstudy = store.getters.getStudyIs;
          if (defaultstudy == null || defaultstudy == "") {
            if (studies.value.length != 0) {
              store.dispatch("setStudyID", studies.value[0].studyId);
            }
          }
        })
        .catch(async (err) => {
          if (err.response && err.response.status == "401") {
            //token expired..
            await performLogout();
            return;
          }
          console.log(err);
        });
    }
    async function studychange(val) {
      await store.dispatch("setStudyID", val);
      window.dispatchEvent(
        new CustomEvent("studyIdChanged", {
          detail: {
            storage: store.getters.getStudyIs,
          },
        })
      );
    }
    function collapse() {
      const current = store.getters.getCollappseShow;
      store.dispatch("setCollapse", !current);
    }
    function close() {
      if (window.innerWidth <= 769 && document.body.classList.contains("mini-navbar")) {
        document.body.classList.remove("mini-navbar");
      }
    }
    function mouseItemLeave(id) {
      if (isActive.value == false) {
        let expitem = document.getElementById(id);
        if (expitem) expitem.classList.add("collapse");
      }
    }
    //check the screen size and resize navbar

    async function expandmenu() {
      let expitem = document.getElementById("expitm");
      if (expitem) expitem.classList.toggle("collapse");
    }
    async function expandfun(id, index, type) {
      let expitem = document.getElementById(id);
      if (type === "mainmenu") {
        mainmenu.value[index] = !mainmenu.value[index];
        if (document.body.classList.contains("mini-navbar")) {
          collapse();
        }
      } else {
        submenu.value[index] = !submenu.value[index];
      }
      if (expitem) expitem.classList.toggle("collapse");
    }
    async function keepexpanded(id) {
      let expitem = document.getElementById(id);
      if (expitem) expitem.className = "nav nav-second-level";
    }
    async function getStudyDetails() {
      const currentstudyid = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;

      if (!currentstudyid || !idtoken) {
        isArmSpecific.value = false;
        return;
      }

      await axios
        .get(`${baseurl.value}/management/study/getbyid?id=${currentstudyid}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          const currentVersion = res.data && res.data.currentVersion;
          const versions = Array.isArray(res.data && res.data.versions)
            ? res.data.versions
            : [];

          const versionObj = versions.find(
            (version) => version.version === currentVersion
          );

          isArmSpecific.value = !!(versionObj && versionObj.isArmSpecific);
        })
        .catch((err) => console.log("error in get study", err));
    }

    watchEffect(() => {
      collapseSideBar.value = store.getters.getCollappseShow;
      if (collapseSideBar.value === true && isRightActive.value === false) {
        isActive.value = false;
        isRightActive.value = true;
        document.body.classList.add("mini-navbar");
      } else if (
        collapseSideBar.value === false &&
        showArrows.value === false
      ) {
        showArrows.value = true;
        isRightActive.value = false;
        isActive.value = true;
      } else if (
        collapseSideBar.value === false &&
        isRightActive.value === true
      ) {
        showArrows.value = true;
        isRightActive.value = false;
        isActive.value = true;
        submenu.value = [false, false, false, false, false];
        if (document.body.classList.contains("mini-navbar")) {
          document.body.classList.remove("mini-navbar");
        }
      }
    });

    onUnmounted(() => {
      window.removeEventListener("StudyListChanged", onStudyListChanged);
      document.removeEventListener("click", onDocumentClick);
      removeMediaListener(mediaMin, onMinWidthChange);
      removeMediaListener(mediaMax, onMaxWidthChange);
      if (removeRouterGuard) removeRouterGuard();
    });
    return {
      showArrows,
      collapseSideBar,
      returnToLanding,
      currentTheme,
      notcollapsed,
      expandclass,
      isLoginPage,
      authenticated,
      getNavbarstatus,
      user,
      valnow,
      auth0Client,
      usersdetails,
      currentRoleName,
      studies,
      defaultdashbord,
      isArmSpecificcompueted,
      rollsprivilages,
      querycount,
      querylist,
      isActive,
      isRightActive,
      studydetails,
      studyDetails,
      versiondetailsobj,
      isArmSpecific,
      showImportStudy,
      importPopupType,
      currentPage,
      hideSideNavbar,
      showSideNavbar,
      anchorlink,
      languagechange,
      switchTheme,
      displayNotification,
      filterNow,
      filterTime,
      filterDate,
      setdefaultstudy,
      changeStudyList,
      createstudypopup,
      CreateVideoCallSchedulePopUp,
      DefaultSetupPopUp,
      loadstudy,
      studychange,
      mouseItemLeave,
      logout,
      collapse,
      expandmenu,
      getDefaultMenu,
      isGenericMenu,
      expandfun,
      initNav,
      close,
      mainmenu,
      getStudyDetails,
      submenu,
      viewquery,
      viewreceived,
      getquerydetails,
      expandSidebar,
      displayProfile,
      gotoUrl,
      t,
      d,
      importStudypopup,
      gotointelligentdashboard,
      openUploadFile,
      closeModal,
      locale,
      studyFile,
      previewFiles,
      importStudy,
      downloadImportTemplate,
      validations,
      showLoading,
      validateNull,
      showupload,
      showselectstudy,
      mobileNavOpen,
      mobileThemeOpen,
      //ViewReportPopUp
    };
  },
};
</script>

<style>
@import "../../assets/css/style.css";
@import "../../assets/formpage.css";
@media (max-width: 768px) {
  /* Single-row navbar: override the global 101px two-row height */
  .navbar.navbar-static-top {
    padding: 0 !important;
    height: 52px !important;
    flex-wrap: nowrap !important;
    overflow: visible;
  }

  /* Swap full logos for compact logos — scoped to the main app nav only.
     The landing page nav sits outside .border-bottom and has no .logo-element
     fallback, so this rule intentionally does NOT affect it. */
  .border-bottom .navbar-logo {
    display: none !important;
  }
  .border-bottom .logo-element {
    display: flex !important;
    align-items: center;
    padding: 14px 12px;
  }

  .navbar-header {
    align-self: center;
    flex-shrink: 0;
  }
  .navbar-header-bg {
    background-color: #ffffff;
    padding: 1px 4px;
  }

  /* Constrain study selector so it doesn't consume all space */
  .study-select {
    max-width: 110px;
    min-width: 80px;
  }

  /* Tighten icon spacing */
  .nav.navbar-top-links > li {
    padding-left: 3px !important;
    padding-right: 3px !important;
  }

  .minimalize-styl-2 {
    margin: 0 !important;
  }

  .nav > li > a i {
    font-size: 1em;
  }

  #wrapper {
    position: relative !important;
  }

  .pace-done #page-wrapper,
  .body.mini-navbar #page-wrapper {
    position: relative;
  }

  #mobilemenu.navbar-static-side,
  #mobilemenu.navbar-default {
    transition: all ease-in-out 400ms !important;
  }

  .mini-navbar #mobilemenu > div {
    width: 87px;
    transition: width ease-in-out 400ms !important;
  }

  .angle-down-right {
    float: left;
    margin-left: 45%;
  }

  /* Hide desktop nav icons, show hamburger */
  .border-bottom .nav.navbar-top-links {
    display: none !important;
  }
  .mobile-hamburger {
    display: flex !important;
  }
}

/* ── Mobile hamburger button (hidden at desktop) ─────────────────── */
.mobile-hamburger {
  display: none;
  background: none;
  border: none;
  padding: 8px 12px;
  margin-left: auto;
  cursor: pointer;
  color: #ffffff;
  font-size: 1.3em;
  align-items: center;
  justify-content: center;
  line-height: 1;
  flex-shrink: 0;
}

/* ── Mobile nav overlay ──────────────────────────────────────────── */
.mobile-nav-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 3000;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}
.mobile-nav-overlay.is-visible {
  opacity: 1;
  pointer-events: all;
}

/* ── Mobile nav drawer ───────────────────────────────────────────── */
.mobile-nav-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 280px;
  height: 100vh;
  background: #145faf;
  z-index: 3001;
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
  overflow-y: auto;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.18);
}
.mobile-nav-drawer.is-open {
  transform: translateX(0);
}

.mobile-nav-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  height: 52px;
  background: var(--background-primary, #145faf);
  color: #fff;
  flex-shrink: 0;
}
.mobile-nav-title {
  font-weight: 600;
  font-size: 15px;
}
.mobile-nav-close-btn {
  background: none;
  border: none;
  color: #fff;
  font-size: 1.2em;
  cursor: pointer;
  padding: 4px 8px;
  line-height: 1;
}

.mobile-nav-content {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
  background:var(--secondary-color);
}

.mobile-nav-section {
  padding: 10px 16px;
}

.mobile-study-select {
  width: 100%;
  padding: 7px 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 13px;
  color: #676a6c;
  background: #fff;
}

.mobile-nav-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.mobile-nav-list-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 13px 16px;
  cursor: pointer;
  font-size: 13px;
  color: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.15s;
  background:var(--secondary-color)
}
.mobile-nav-list-item:hover {
  background: var(--hvr-color);
}
.mobile-nav-list-item img {
  width: 22px;
  height: 22px;
  object-fit: contain;
  flex-shrink: 0;
}

.mobile-query-badge {
  margin-left: auto;
  background: #ed5565;
  color: #fff;
  border-radius: 10px;
  padding: 0 6px;
  font-size: 11px;
  line-height: 18px;
  min-width: 18px;
  text-align: center;
}

.mobile-user-section {
  padding: 4px 0;
}
.mobile-user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #eaf5ff;
  border-top: 1px solid #e9ecef;
  border-bottom: 1px solid #e9ecef;
}
.mobile-profile-pic {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
.mobile-user-name {
  display: flex;
  flex-direction: column;
  font-size: 13px;
}
.mobile-theme-submenu {
  background: #f8f9fa;
  border-bottom: 1px solid #f0f0f0;
}
.mobile-nav-profile-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 13px 16px;
  cursor: pointer;
  font-size: 13px;
  color: #000000;
  border-bottom: 1px solid #f0f0f0;
  background: #eaf5ff;
  transition: background 0.15s;
}
.mobile-nav-profile-item:hover {
  background: #f5f8ff;
}
.mobile-theme-item {
  padding: 10px 16px 10px 50px;
  cursor: pointer;
  font-size: 13px;
  color: #676a6c;
  transition: background 0.15s;
}
.mobile-theme-item:hover {
  background: #e9f0fb;
}

.theme-default {
  /* Button color change property */
  --primary-color: #007bff;
  --hvr-color: #2d91fb;
  --secondary-color: #618bd7;

  /*   Dashboard title color change property */
  --pagination-active-clr: rgb(97, 139, 215);
  --icon-color: #68696b;
  --icon-white: #ffffff;
  --background-primary: #145faf;
  --background-secondary: #618bd7;
  --pop-up-background: #618bd7;
  --pop-up-background-light: #d9e4ff;
}

.theme-green {
  --primary-color: #008080;
  --hvr-color: #46b0b0;
  --secondary-color: #46b0b0;
  --pagination-active-clr: #46b0b0;
  --icon-color: #008080;
  --background-primary: #008080;
  --background-secondary: #46b0b0;
  --background-neutral: #00bfbf;
  --pop-up-background: #46b0b0;
  --pop-up-background-light: rgba(0, 177, 177, 0.2);
}

.theme-violet {
  --primary-color: #716d97;
  --hvr-color: #ac82a7;
  --secondary-color: #ac82a7;
  --pagination-active-clr: #ac82a7;
  --icon-color: #716d97;
  --background-primary: #716d97;
  --background-secondary: #ac82a7;
  --background-neutral: #928faf;
  --pop-up-background-ligh: rgba(106, 70, 102, 0.3);
}

.theme-ocian {
  --primary-color: #31806c;
  --hvr-color: #1fb58f;
  --secondary-color: #1fb58f;
  --pagination-active-clr: #1fb58f;
  --icon-color: #31806c;
  --background-primary: #31806c;
  --background-secondary: #1fb58f;
  --background-neutral: #56bea4;
  --pop-up-background: #1fb58f;
  --pop-up-background-light: rgba(49, 128, 108, 0.3);
}

.theme-stormy {
  --primary-color: #494e68;
  --hvr-color: #6d7993;
  --secondary-color: #6d7993;
  --pagination-active-clr: #6d7993;
  --icon-color: #494e68;
  --background-primary: #494e68;
  --background-secondary: #6d7993;
  --background-neutral: #767c9f;
  --pop-up-background: #6d7993;
  --pop-up-background-light: rgba(73, 78, 104, 0.3);
}

.theme-pastel {
  --primary-color: #80461b;
  --hvr-color: #c06014;
  --secondary-color: #c06014;
  --pagination-active-clr: #c06014;
  --icon-color: #80461b;
  --background-primary: #80461b;
  --background-secondary: #c06014;
  --background-neutral: #de9661;
  --pop-up-background: #c06014;
  --pop-up-background-light: rgba(146, 80, 31, 0.3);
}

.close-btn {
  position: absolute;
  right: 10px;
  font-size: 20px;
  top: 0;
  display: none;
}

.btn-cps {
  color: #fff;
  float: inherit;
  transition: background-color ease-in-out 300ms;
  font-size: 30px;
  /* position: absolute;
  float:inline-start;
  padding-left:232px; */
}
/* }
@media (max-width: 1024px) {
  .btn-cps {
  color: #fff;
  float: inherit;
  transition: background-color ease-in-out 300ms;
  font-size: 30px;
  position: absolute;
  left: 25%;
  top: 2%;
  }
}
@media (max-width: 768px) {
  .btn-cps {
  color: #fff;
  float: inherit;
  transition: background-color ease-in-out 300ms;
  font-size: 30px;
  position: absolute;
  left: 33%;
  top: 2%;
  }
} */

.btn-cps:hover {
  color: #fff;
}

.btn-cps:active {
  color: #fff;
  background-color: #4882da;
  border-color: #4882da;
}

.submenuitem {
  width: 100% !important;
}

a {
  text-decoration: none !important;
}

.dropdown {
  height: 100%;
}

.profile-pic {
  border-radius: 50%;
  width: 29px;
  height: 29px;
  object-fit: cover;
}

.logindetails {
  margin-left: 10px;
  text-align: center;
  margin-top: 10px;
  -webkit-transition: display ease-in-out 400ms;
  transition: display ease-in-out 400ms;
}

.nav.navbar-top-links > li > a:hover,
.nav.navbar-top-links > li > a:focus {
  color: #ffffff !important;
}

.fullwidthquery {
  width: 100%;
}

#page-wrapper.page-wrapper--full-width,
body.mini-navbar #page-wrapper.page-wrapper--full-width,
body.fixed-sidebar #page-wrapper.page-wrapper--full-width {
  width: 100%;
  max-width: 100%;
  margin-left: 0;
  flex: 1 1 100%;
}

.thirdlevel {
  margin-left: 25px !important;
}

.navbar-fixed-top,
.navbar-static-top {
  background: var(--secondary-color) !important;
  transition: background-color 0.5 s ease-in-out;
}

nav.navbar-static-top {
  position: relative;
  z-index: 2060;
}

.query-icon {
  position: relative;
  color: white !important;
}

.query-count {
  position: absolute;
  right: 42px;
  top: 12px;
}

.query-count:empty {
  display: none;
}

.login-user-details {
  padding: 0 0.8rem;
}

.user-details > div {
  cursor: pointer;
}

.user-details {
  padding: 0 0.9rem 0.5rem 0.9rem;
}

.user-details > div:hover,
.user-details > div:focus,
.user-details > div:focus-within {
  background-color: rgba(0, 0, 0, 0.08);
}

.notification-block {
  color: var(--bs-dark);
  font-family: var(--bs-font-sans-serif);
  background-color: #ffffff;
  width: min(300px, 100vw);
  border: medium none;
  border-radius: 3px;
  display: none;
  float: left;
  font-size: 12px;
  top: 60px;
  right: 0;
  list-style: none outside none;
  padding: 0.4rem 0.9rem;
  position: absolute;
  text-shadow: none;
  z-index: 2070;
  box-shadow: 0 24px 54px rgba(0, 0, 0, 0.15),
    0 4.5px 13.5px rgba(0, 0, 0, 0.08);
  -webkit-box-shadow: 0 24px 54px rgba(0, 0, 0, 0.15),
    0 4.5px 13.5px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: 0 24px 54px rgba(0, 0, 0, 0.15),
    0 4.5px 13.5px rgba(0, 0, 0, 0.08);
}

.profile-block {
  position: absolute;
  color: var(--bs-dark);
  font-family: var(--bs-font-sans-serif);
  background-color: #ffffff;
  width: max-content;
  border: medium none;
  border-radius: 3px;
  display: none;
  font-size: 12px;
  top: 60px;
  right: 10px;
  text-shadow: none;
  z-index: 2070;
  box-shadow: 0 24px 54px rgba(0, 0, 0, 0.15),
    0 4.5px 13.5px rgba(0, 0, 0, 0.08);
  -webkit-box-shadow: 0 24px 54px rgba(0, 0, 0, 0.15),
    0 4.5px 13.5px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: 0 24px 54px rgba(0, 0, 0, 0.15),
    0 4.5px 13.5px rgba(0, 0, 0, 0.08);
}

.position-relative {
  position: relative;
}

.profile-block > div > *:not(span) {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.profile-image {
  max-width: 100%;
  width: 30px;
  height: 30px;
}

.message-body {
  position: relative;
}

.message-body::after {
  content: "";
  position: absolute;
  display: block;
  bottom: 3px;
  width: 100%;
  height: 0.5px;
  background-color: rgba(0, 0, 0, 0.15);
}

.message-body > * {
  width: fit-content;
  font-size: 0.76rem;
  line-height: 1.3;
}

.animate {
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.btn-raise-query {
  color: #68696b;
  padding: 0.11rem 0.4rem;
  border-radius: 30px;
  text-align: center;
  font-size: 10px;
  background-color: #ffffff !important;
}

.theme-menu {
  position: absolute;
  display: none;
  width: 220px;
  top: 135px;
  right: 0px;
  background: #f3f3f4;
  z-index: 2100;
  overflow: hidden;
  border-radius: 3px;
  box-shadow: -1px 6px 45px -25px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: -1px 6px 45px -25px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -1px 6px 45px -25px rgba(0, 0, 0, 0.75);
  font-family: var(--bs-font-sans-serif);
}

.theme-menu .title {
  text-align: center;
  text-transform: uppercase;
  font-weight: 600;
  display: block;
  padding: 10px 15px;
  font-size: 12px;
  color: #000000;
}

.study-select {
  display: block;
  width: 100%;
  padding: 0.075rem 2rem 0.075rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 0.35rem center;
  background-size: 15px 12px;
  border: 1px solid #ced4da;
  border-radius: 3px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.study-select:focus,
.study-select:focus-within,
.study-select:focus-visible {
  outline: none;
}

.nav-link:hover,
.nav-link:focus {
  color: #68696b !important;
}
.angle-down-right {
  transition: transform 200ms;
}
.rotate-down {
  transform: rotate(90deg);
}
.rotate-down {
  transform: rotate(-90deg);
}
.add-study-popup {
  position: relative;
}
.add-study-popup .tool-tip {
  visibility: hidden;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.2rem 0.7rem;
  right: 25px;
  top: 20px;
  font-size: 0.7rem;
  position: absolute;
  z-index: 1;
  transition: visibility 75ms ease-in;
}

.add-study-popup:hover .tool-tip,
.add-study-popup:focus .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}
#formlibrarysetup {
  bottom: 2px;
  top: auto;
}
.mini-navbar #studysetup {
  width: 300px;
}
.general-query .tool-tip {
  visibility: hidden;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.2rem 0.7rem;
  right: 110px;
  top: 36px;
  font-size: 0.7rem;
  position: absolute;
  z-index: 1;
  transition: visibility 75ms ease-in;
}

.general-query:hover .tool-tip,
.general-query:focus .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}
.received-query .tool-tip {
  visibility: hidden;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.2rem 0.7rem;
  right: 70px;
  top: 36px;
  font-size: 0.7rem;
  position: absolute;
  z-index: 1;
  transition: visibility 75ms ease-in;
}

.received-query:hover .tool-tip,
.received-query:focus .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}

#formlibrarysetup {
  bottom: 2px;
  top: auto;
}
.mini-navbar #studysetup {
  width: 300px;
}
.general-query .tool-tip {
  visibility: hidden;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.2rem 0.7rem;
  right: 110px;
  top: 36px;
  font-size: 0.7rem;
  position: absolute;
  z-index: 1;
  transition: visibility 75ms ease-in;
}
.general-query:hover .tool-tip,
.general-query:focus .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}
.received-query .tool-tip {
  visibility: hidden;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.2rem 0.7rem;
  right: 70px;
  top: 36px;
  font-size: 0.7rem;
  position: absolute;
  z-index: 1;
  transition: visibility 75ms ease-in;
}

.received-query:hover .tool-tip,
.received-query:focus .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}
.user-profile .tool-tip {
  visibility: hidden;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.2rem 0.7rem;
  right: 28px;
  top: 36px;
  font-size: 0.7rem;
  position: absolute;
  z-index: 1;
  transition: visibility 75ms ease-in;
}

.user-profile:hover .tool-tip,
.user-profile:focus .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}

.import_study:hover .tool-tip,
.import_study:focus .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}

.badge-pending {
  background-color: orange; /* pending color */
  color: white;
  font-size: 0.55rem;
  font-weight: bold;
  border-radius: 50%;
  padding: 1px 5px;
  margin-left: 2px;
  vertical-align: super;
}
</style>
